<div class="site-page">

  @if (groupContext()) {
    <!-- Drill-down Groupe -> Site (ajustement navigation 2026-09-07) : même header + même niveau que
         la Vue d'ensemble Groupe (titre "Prévention", nav principale), jamais dupliqué/reformulé --
         suivi d'un fil d'ariane au même gabarit que les autres sous-pages du domaine Groupe Prévention
         (bouton "Retour" en breadcrumb-back) mais SANS second contrôle cliquable redondant : "Vue
         d'ensemble" reste un simple repère de position (breadcrumb-current, non cliquable), le bouton
         Retour est l'unique action de retour. Jamais de répétition de "Prévention" (déjà porté par le
         header ci-dessus). Ni sélecteur de site ni onglets ici -- sous-page de pilotage Groupe, pas une
         navigation Site indépendante. -->
    <app-prevention-group-header activeTab="overview"></app-prevention-group-header>
    <div class="breadcrumb-bar">
      <button class="breadcrumb-back" (click)="backToGroupOverview()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        {{ 'site.common.back' | translate }}
      </button>
      <span class="breadcrumb-sep">·</span>
      <span class="breadcrumb-current">{{ 'pilotagePrevention.nav.overview' | translate }}</span>
      <span class="breadcrumb-sep">·</span>
      <span class="breadcrumb-current">{{ groupContextSiteName() }}</span>
    </div>
  } @else {
    <!-- En-tête -->
    <div class="page-hd">
      <app-page-site-switcher [variant]="'header'"></app-page-site-switcher>
      <p class="subtitle">{{ 'site.header.subtitle' | translate }}</p>
    </div>

    <!-- Onglets -->
    <div class="site-tabs">
    <button (click)="activeTab.set('comm')" [class.active]="activeTab() === 'comm'">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>
      {{ 'site.tabs.comm' | translate }}
    </button>
    @if (hasPreventionPermission) {
    <button (click)="activeTab.set('prevention')" [class.active]="activeTab() === 'prevention'">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12.5 20.3c-.3.2-.7.2-1 0C7.6 17.8 3.4 14.2 3.4 9.9 3.4 7.1 5.5 5.2 8 5.2c1.4 0 2.7.7 3.6 1.8.9-1.1 2.2-1.8 3.6-1.8 2.5 0 4.6 1.9 4.6 4.7 0 4.3-4.2 7.9-8.3 10.4z"/><path d="M5.2 12.2h2.6l1.4-2.8 1.9 4.6 1.4-2.8h6.3"/></svg>
      {{ 'site.tabs.prevention' | translate }}
    </button>
    }
    <button (click)="activeTab.set('sat')" [class.active]="activeTab() === 'sat'">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
      {{ 'site.tabs.sat' | translate }}
    </button>
    <button (click)="activeTab.set('params')" [class.active]="activeTab() === 'params'">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
      {{ 'site.tabs.params' | translate }}
    </button>
    </div>
  }

  <!-- ════════════════════════════════════════ COMMUNICATION PATIENT ════ -->
  @if (activeTab() === 'comm') {

    <!-- Sous-page Accueil -->
    @if (showAccueilSubpage()) {
      <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          <button class="breadcrumb-back" (click)="closeAccueil()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.communication' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.realtime' | translate }}</span>
        </div>
      </div>
      <div class="accueil-subpage">
        <div style="display:grid;grid-template-columns:repeat(auto-fill, minmax(360px, 1fr));gap:16px">
          @for (q of session.queues(); track q.id) {
            <app-queue-card [queue]="q"></app-queue-card>
          }
        </div>
      </div>
    }

    <!-- Sous-page Prévisions / Ajustement manuel -->
    @if (showPrevisionSubpage()) {
      <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          @if (previsionComp.showProfileIaSubpage() || previsionComp.showAjustementManuelSubpage()) {
            <button class="breadcrumb-back" (click)="previsionComp.showProfileIaSubpage() ? previsionComp.closeProfileIaSubpage() : previsionComp.closeAjustementManuelSubpage()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              {{ 'site.common.back' | translate }}
            </button>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current breadcrumb-link" (click)="previsionComp.closeProfileIaSubpage(); previsionComp.closeAjustementManuelSubpage()">{{ 'site.breadcrumb.previsions' | translate }}</span>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ (previsionComp.showProfileIaSubpage() ? 'site.breadcrumb.configIa' : 'site.breadcrumb.manualAdjustment') | translate }}</span>
          } @else {
            <button class="breadcrumb-back" (click)="closePrevision()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              {{ 'site.common.back' | translate }}
            </button>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ 'site.breadcrumb.communication' | translate }}</span>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ 'site.breadcrumb.previsions' | translate }}</span>
          }
        </div>
        @if (!previsionComp.showProfileIaSubpage() && !previsionComp.showAjustementManuelSubpage()) {
          <div class="breadcrumb-actions">
            <button class="action-pill" (click)="previsionComp.openManualAdjustment()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              {{ 'site.breadcrumb.manualAdjustment' | translate }}
            </button>
          </div>
        }
      </div>
      <div class="prevision-subpage">
        <app-previsions #previsionComp [inline]="true"></app-previsions>
      </div>
    }

    <!-- Sous-page Actus / Préventions -->
    @if (showActuSubpage()) {
      <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          <button class="breadcrumb-back" (click)="closeActu()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.communication' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.actus' | translate }}</span>
        </div>
      </div>
      <div class="actu-subpage">
        <app-fil-actualite [inline]="true"></app-fil-actualite>
      </div>
    }

    <!-- Sous-page Kit de communication -->
    @if (showKitSubpage()) {
      <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          <button class="breadcrumb-back" (click)="closeKit()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.communication' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.kitPatient' | translate }}</span>
        </div>
      </div>
      <div class="kit-subpage">
        <app-qr-modal
          [establishmentId]="session.selectedId()"
          [inline]="true"
          (close)="closeKit()">
        </app-qr-modal>
      </div>
    }

    <!-- Contenu principal comm -->
    @if (!showAccueilSubpage() && !showKitSubpage() && !showActuSubpage() && !showPrevisionSubpage()) {
    <div class="two-col">

      <!-- Colonne gauche -->
      <div class="col">

        <!-- Temps réel files -->
        <div class="card" #tempsReelCard>
          <div class="flex-jb" style="margin-bottom:14px">
            <div class="ct">
              {{ 'site.comm.realtime.title' | translate }}
              <span class="live-indicator">
                <span class="live-dot"></span>
                <span class="live-text">{{ 'site.comm.realtime.live' | translate }}</span>
              </span>
            </div>
            <button class="btn-primary-sm" (click)="openAccueil()">{{ 'site.common.seeMore' | translate }}</button>
          </div>
          <div style="display:grid;grid-template-columns:1fr;gap:12px">
            @if (session.queues().length > 0) {
              <app-queue-card [queue]="session.queues()[0]"></app-queue-card>
            }
          </div>
        </div>

      </div>

      <!-- Colonne droite -->
      <div class="col">

        <!-- Actus / Préventions -->
        <div class="card" style="display:flex;flex-direction:column;overflow:hidden" [style.maxHeight.px]="tempsReelHeight()">
          <div class="flex-jb" style="margin-bottom:14px">
            <div class="ct">{{ 'site.breadcrumb.actus' | translate }}</div>
            @if (hasFilActualitePermission) {
              <button class="btn-primary-sm" (click)="openActu()">+ {{ 'site.common.add' | translate }}</button>
            }
          </div>
          <div style="display:flex;flex-direction:column;gap:10px;flex:1;min-height:0;overflow-y:auto">
            @for (msg of lastActus(); track msg.id) {
              <div class="actu-item">
                @if (getActuImageUrl(msg.id); as imgUrl) {
                  <img [src]="imgUrl" style="width:40px;height:40px;border-radius:6px;object-fit:cover;flex-shrink:0" alt="">
                } @else {
                  <div class="actu-avatar" style="background:#F0F4FF;display:flex;align-items:center;justify-content:center">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9AA3B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                  </div>
                }
                <div style="flex:1;min-width:0">
                  <div class="toggle-label" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ msg.titre }}</div>
                  <div class="cs" style="margin-top:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ msg.description }}</div>
                </div>
                <span class="cs" style="flex-shrink:0;color:#9AA3B2">{{ formatActuDate(msg.createdAt) }}</span>
              </div>
            } @empty {
              <div class="cs" style="color:#9AA3B2;text-align:center;padding:12px 0">{{ 'site.comm.actus.empty' | translate }}</div>
            }
          </div>
        </div>

      </div>

    </div>

    <!-- Prévisions d'affluence - par motif de visite -->
    <div class="card" style="margin-top:16px">
      <div class="flex-jb" style="margin-bottom:4px;flex-wrap:wrap;gap:8px">
        <div>
          <div class="ct">{{ 'site.comm.forecast.title' | translate }}</div>
          <div class="cs">{{ 'site.comm.forecast.subtitle' | translate }}</div>
        </div>
        <div style="display:flex;align-items:center;gap:16px">
          <div style="display:flex;gap:12px;align-items:center">
            <span style="display:flex;align-items:center;gap:4px;font-size:10px;color:var(--mu)"><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:#513e9b"></span>{{ 'site.comm.forecast.legend.normal' | translate }}</span>
            <span style="display:flex;align-items:center;gap:4px;font-size:10px;color:var(--mu)"><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:#f59e0b"></span>{{ 'site.comm.forecast.legend.high' | translate }}</span>
            <span style="display:flex;align-items:center;gap:4px;font-size:10px;color:var(--mu)"><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:#ef4444"></span>{{ 'site.comm.forecast.legend.peak' | translate }}</span>
          </div>
          <button class="btn-primary-sm" (click)="openPrevision()">{{ 'site.common.seeMore' | translate }}</button>
        </div>
      </div>
      <div class="projection-controls" style="margin-top:12px">
        <select class="select-ctrl" [value]="graphQueueId()" (change)="onGraphQueueChanged($any($event.target).value)">
          @for (q of session.queues(); track q.id) {
            <option [value]="q.id">{{ q.name }}</option>
          }
        </select>
        <div class="day-selector-inline">
          @for (day of days; track day.value) {
            <button class="day-btn" [class.day-btn-active]="selectedGraphDay() === day.value" (click)="selectGraphDay(day.value)">{{ day.labelKey | translate }}</button>
          }
        </div>
      </div>
      <div class="projection-graph">
        <app-forecast-graph
          [queueId]="graphQueueId()"
          [bare]="true"
          [lowThreshold]="session.affluenceThresholds()?.waitLowMinutes ?? 10"
          [highThreshold]="session.affluenceThresholds()?.waitHighMinutes ?? 20"
          [dayOfWeek]="selectedGraphDay()"
          [showValues]="true"
          [barColorLow]="'#513e9b'"
          [barColorMid]="'#f59e0b'"
          [barColorHigh]="'#ef4444'">
        </app-forecast-graph>
      </div>
    </div>

    <div class="two-col two-col--stretch" style="margin-top:16px">

      <!-- Colonne gauche -->
      <div class="col">

        <!-- Message patient – par motif de visite -->
        <div class="card">
          <div class="ct" style="margin-bottom:14px">{{ 'site.comm.message.title' | translate }}</div>
          <div style="display:flex;flex-direction:column;gap:10px">
            @for (q of session.queues(); track q.id) {
              <div class="msg-file">
                <div class="msg-file-head" style="justify-content:space-between">
                  <div style="display:flex;align-items:center;gap:8px">
                    <div style="width:8px;height:8px;border-radius:50%" [style.background]="queueAffluenceColor(q)"></div>
                    <span style="font-size:12px;font-weight:800;color:var(--ink)">{{ q.name }}</span>
                  </div>
                  @if (editingQueueId() !== q.id) {
                    <button class="btn-ps-sm" (click)="startEditMessage(q)">{{ 'site.common.edit' | translate }}</button>
                  }
                </div>
                @if (editingQueueId() === q.id) {
                  <div style="margin-top:8px;display:flex;flex-direction:column;gap:8px">
                    <textarea
                      class="textarea-ctrl"
                      rows="3"
                      [value]="editingMessage()"
                      (input)="editingMessage.set($any($event.target).value)"
                      [placeholder]="'site.comm.message.placeholder' | translate"
                    ></textarea>
                    <div style="display:flex;gap:8px;justify-content:flex-end">
                      <button class="btn-danger-sm" (click)="cancelEditMessage()" [disabled]="isSavingMessage()">{{ 'site.common.cancel' | translate }}</button>
                      <button class="btn-ps-sm" (click)="saveMessage(q.id)" [disabled]="isSavingMessage()">
                        {{ (isSavingMessage() ? 'site.comm.message.saving' : 'site.comm.message.save') | translate }}
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="msg-text" style="margin-top:6px" [style.color]="q.patient_message ? 'var(--ink)' : 'var(--mu)'">
                    {{ q.patient_message || ('site.comm.message.none' | translate) }}
                  </div>
                }
              </div>
            }
            @if (session.queues().length === 0) {
              <div class="cs">{{ 'site.comm.message.noQueues' | translate }}</div>
            }
          </div>
          <div class="cs" style="margin-top:12px">{{ 'site.comm.message.helpText' | translate }}</div>
        </div>

        <!-- Paramètres d'affichage -->
        <div class="card">
          <div class="ct" style="margin-bottom:14px">{{ 'site.comm.displaySettings.title' | translate }}</div>
          <div style="display:flex;flex-direction:column;gap:8px">
            <div class="toggle-row-item" (click)="toggleShowWaitTime()" style="cursor:pointer">
              <div><div class="toggle-label">{{ 'site.comm.displaySettings.showWaitTime.label' | translate }}</div><div class="toggle-sub">{{ (showWaitTime() ? 'site.comm.displaySettings.showWaitTime.subOn' : 'site.comm.displaySettings.showWaitTime.subOff') | translate }}</div></div>
              <div [class]="showWaitTime() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="togglePreventionStartOnLaunch()" [style.cursor]="preventionPointEnabled() ? 'pointer' : 'not-allowed'" [style.opacity]="preventionPointEnabled() ? 1 : 0.6">
              <div>
                <div class="toggle-label">{{ 'site.comm.displaySettings.preventionStartOnLaunch.label' | translate }}</div>
                <div class="toggle-sub">{{ (preventionPointEnabled() ? 'site.comm.displaySettings.preventionStartOnLaunch.subEnabled' : 'site.comm.displaySettings.preventionStartOnLaunch.subDisabled') | translate }}</div>
              </div>
              <div [class]="preventionPointEnabled() && preventionStartOnLaunch() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="togglePatientReason()" style="cursor:pointer">
              <div><div class="toggle-label">{{ 'site.comm.displaySettings.askReason.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.displaySettings.askReason.sub' | translate }}</div></div>
              <div [class]="showPatientReason() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="toggleShowForecast()" [style.cursor]="showWaitTime() ? 'pointer' : 'not-allowed'" [style.opacity]="showWaitTime() ? 1 : 0.6">
              <div><div class="toggle-label">{{ 'site.comm.displaySettings.showForecast.label' | translate }}</div><div class="toggle-sub">{{ (showWaitTime() ? 'site.comm.displaySettings.showForecast.sub' : 'site.comm.displaySettings.showForecast.subDisabled') | translate }}</div></div>
              <div [class]="showWaitTime() && showForecast() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="toggleShowFeelingSection()" style="cursor:pointer">
              <div><div class="toggle-label">{{ 'site.comm.displaySettings.feelingSection.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.displaySettings.feelingSection.sub' | translate }}</div></div>
              <div [class]="showFeelingSection() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="toggleShowGoogleReview()" [style.cursor]="hasGooglePlace() ? 'pointer' : 'not-allowed'" [style.opacity]="hasGooglePlace() ? 1 : 0.6">
              <div>
                <div class="toggle-label">{{ 'site.comm.displaySettings.googleReview.label' | translate }}</div>
                <div class="toggle-sub">{{ (hasGooglePlace() ? 'site.comm.displaySettings.googleReview.subEnabled' : 'site.comm.displaySettings.googleReview.subDisabled') | translate }}</div>
              </div>
              <div [class]="hasGooglePlace() && showGoogleReview() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="toggleShowPatientReply()" style="cursor:pointer">
              <div><div class="toggle-label">{{ 'site.comm.displaySettings.patientReply.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.displaySettings.patientReply.sub' | translate }}</div></div>
              <div [class]="showPatientReply() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <div class="toggle-row-item" (click)="toggleShowUnderstandCare()" style="cursor:pointer">
              <div><div class="toggle-label">{{ 'site.comm.displaySettings.understandCare.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.displaySettings.understandCare.sub' | translate }}</div></div>
              <div [class]="showUnderstandCare() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
          </div>
        </div>

      </div>

      <!-- Colonne droite -->
      <div class="col">

        <!-- Kit de communication -->
        <div class="card">
          <div class="flex-jb" style="margin-bottom:14px">
            <div class="ct">{{ 'site.comm.kit.title' | translate }}</div>
            <button class="btn-primary-sm" (click)="openKit()">{{ 'site.common.seeMore' | translate }}</button>
          </div>
          <div class="cs" style="margin-bottom:14px">{{ 'site.comm.kit.subtitle' | translate }}</div>
          <div style="display:flex;flex-direction:column;gap:8px">
            <div class="kit-item" style="flex-direction:column;align-items:stretch">
              <div style="display:flex;align-items:center;justify-content:space-between">
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="kit-icon">🌐</div>
                  <div><div class="toggle-label">{{ 'site.comm.kit.widget.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.kit.widget.sub' | translate }}</div></div>
                </div>
                <div style="display:flex;align-items:center;gap:10px">
                  <!-- Une seule langue configurée : pas de choix à faire, le lien remonte directement
                       sur la ligne du toggle plutôt qu'une liste à une seule entrée en dessous
                       (2026-09-02) -- le drapeau/libellé de langue n'apporte rien ici, jamais affiché. -->
                  @if (widgetEnabled() && widgetLanguageLinks().length === 1) {
                    <button class="btn-ps-sm" style="display:inline-flex;align-items:center;gap:5px" (click)="copyLanguageUrl(widgetLanguageLinks()[0].url, widgetLanguageLinks()[0].label)">
                      <img class="icon-16" src="/assets/copy.svg" alt="" />
                      {{ 'site.comm.kit.widget.copyLink' | translate }}
                    </button>
                  }
                  <div (click)="toggleWidget()" style="cursor:pointer" [class]="widgetEnabled() ? 'toggle-on' : 'toggle-off'"></div>
                </div>
              </div>
              <!-- >=2 langues actives : une ligne par langue, widget.html est traduit et fixe sa
                   langue via ?lang= (voir i18n-patient.js) -- ici le choix de langue a un sens. -->
              @if (widgetEnabled() && widgetLanguageLinks().length > 1) {
                <div style="display:flex;flex-direction:column;gap:6px;margin-top:10px;padding-left:46px">
                  @for (lang of widgetLanguageLinks(); track lang.code) {
                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px">
                      <span style="display:flex;align-items:center;gap:6px;font-size:12px;color:var(--mu)">
                        <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)">
                        {{ lang.label }}
                      </span>
                      <button class="btn-ps-sm" style="display:inline-flex;align-items:center;gap:5px" (click)="copyLanguageUrl(lang.url, lang.label)">
                        <img class="icon-16" src="/assets/copy.svg" alt="" />
                        {{ 'site.comm.kit.widget.copyLink' | translate }}
                      </button>
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Widget Doctolib (2026-09-02) -- même lien org-scopé que la section "Widget Affluence
                 Doctolib" du Kit de communication complet (qr-modal.component.ts: doctolibWidgetUrl),
                 pas une donnée établissement, réutilisé tel quel. -->
            <div class="kit-item">
              <div style="display:flex;align-items:center;gap:10px">
                <div class="kit-icon">🌐</div>
                <div><div class="toggle-label">{{ 'site.comm.kit.widgetDoctolib.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.kit.widgetDoctolib.sub' | translate }}</div></div>
              </div>
              <button class="btn-ps-sm" style="display:inline-flex;align-items:center;gap:5px" [disabled]="!doctolibWidgetUrl()" (click)="openDoctolibWidget()">
                <img class="icon-16" src="/assets/preview.svg" alt="" />
                {{ 'site.comm.kit.widgetDoctolib.openLink' | translate }}
              </button>
            </div>

            <!-- TV : écran d'attente kiosque, même principe que le widget (2026-09-02) -- une seule
                 langue configurée : pas de sélection à faire, le lien remonte directement sur la
                 ligne du libellé (pas de toggle ici, contrairement au widget) plutôt qu'une liste à
                 une seule entrée en dessous ; drapeau/libellé de langue jamais affiché dans ce cas. -->
            @if (tvLanguageLinks().length) {
              <div class="kit-item" style="flex-direction:column;align-items:stretch">
                <div style="display:flex;align-items:center;justify-content:space-between;gap:10px">
                  <div style="display:flex;align-items:center;gap:10px">
                    <div class="kit-icon">📺</div>
                    <div><div class="toggle-label">{{ 'site.comm.kit.tv.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.kit.tv.sub' | translate }}</div></div>
                  </div>
                  @if (tvLanguageLinks().length === 1) {
                    <button class="btn-ps-sm" style="display:inline-flex;align-items:center;gap:5px;flex-shrink:0" (click)="copyLanguageUrl(tvLanguageLinks()[0].url, tvLanguageLinks()[0].label)">
                      <img class="icon-16" src="/assets/copy.svg" alt="" />
                      {{ 'site.comm.kit.widget.copyLink' | translate }}
                    </button>
                  }
                </div>
                <!-- >=2 langues actives : une ligne par langue, choix pertinent ici. -->
                @if (tvLanguageLinks().length > 1) {
                  <div style="display:flex;flex-direction:column;gap:6px;margin-top:10px;padding-left:46px">
                    @for (lang of tvLanguageLinks(); track lang.code) {
                      <div style="display:flex;align-items:center;justify-content:space-between;gap:8px">
                        <span style="display:flex;align-items:center;gap:6px;font-size:12px;color:var(--mu)">
                          <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)">
                          {{ lang.label }}
                        </span>
                        <button class="btn-ps-sm" style="display:inline-flex;align-items:center;gap:5px" (click)="copyLanguageUrl(lang.url, lang.label)">
                          <img class="icon-16" src="/assets/copy.svg" alt="" />
                          {{ 'site.comm.kit.widget.copyLink' | translate }}
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="kit-item">
              <div style="display:flex;align-items:center;gap:10px">
                <div class="kit-icon">🧠</div>
                <div><div class="toggle-label">{{ 'site.comm.kit.quiz.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.kit.quiz.sub' | translate }}</div></div>
              </div>
              <div (click)="toggleQuizEnabled()" style="cursor:pointer" [class]="quizEnabled() ? 'toggle-on' : 'toggle-off'"></div>
            </div>
            <!-- Visible seulement avec le droit PREVENTION (2026-09-02) -- même icône que l'entrée
                 "Prévention" de la sidebar (shell.component.html), pour que le pictogramme se
                 reconnaisse d'un endroit à l'autre de l'app. -->
            @if (hasPreventionPermission) {
              <div class="kit-item">
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="kit-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--p)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5 20.3c-.3.2-.7.2-1 0C7.6 17.8 3.4 14.2 3.4 9.9 3.4 7.1 5.5 5.2 8 5.2c1.4 0 2.7.7 3.6 1.8.9-1.1 2.2-1.8 3.6-1.8 2.5 0 4.6 1.9 4.6 4.7 0 4.3-4.2 7.9-8.3 10.4z"/>
                      <path d="M5.2 12.2h2.6l1.4-2.8 1.9 4.6 1.4-2.8h6.3"/>
                    </svg>
                  </div>
                  <div><div class="toggle-label">{{ 'site.comm.kit.preventionPoint.label' | translate }}</div><div class="toggle-sub">{{ 'site.comm.kit.preventionPoint.sub' | translate }}</div></div>
                </div>
                <div (click)="togglePreventionPointEnabled()" style="cursor:pointer" [class]="preventionPointEnabled() ? 'toggle-on' : 'toggle-off'"></div>
              </div>
            }
          </div>
        </div>

      </div>

    </div>
    }
  }

  <!-- ════════════════════════════════════════ SATISFACTION PATIENT ════ -->
  @if (activeTab() === 'sat') {

    <!-- DEPRECATED (2026-09-11) : sous-page "Fidélisation patient · Qualité" masquée -- bouton
         "Voir plus" de la carte "Indicateurs qualité" retiré (seul déclencheur de
         showQualiteSubpage, voir la note DEPRECATED en tête de site.component.ts). Candidat à la
         suppression complète avec ce bloc quand la fonctionnalité sera vraiment décommissionnée --
         voir cette même note .ts pour le périmètre exact (front + backend) et ce qui doit rester
         actif entre-temps (QualiteComponent est encore utilisé par la route /qualite et par
         statistiques.component.ts).
    @if (showQualiteSubpage()) {
      <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          @if (qualiteComp.showSatisfactionSubpage() || qualiteComp.showObjectifsSubpage() || qualiteComp.showRapportSubpage()) {
            <button class="breadcrumb-back" (click)="qualiteComp.showSatisfactionSubpage() ? qualiteComp.closeSatisfactionSubpage() : qualiteComp.showObjectifsSubpage() ? qualiteComp.closeObjectifsSubpage() : qualiteComp.closeRapportSubpage()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              {{ 'site.common.back' | translate }}
            </button>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current breadcrumb-link" (click)="qualiteComp.closeSatisfactionSubpage(); qualiteComp.closeObjectifsSubpage(); qualiteComp.closeRapportSubpage()">{{ 'site.breadcrumb.qualite' | translate }}</span>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ (qualiteComp.showSatisfactionSubpage() ? 'site.breadcrumb.fidelisation' : qualiteComp.showObjectifsSubpage() ? 'site.breadcrumb.objectifs' : 'site.breadcrumb.rapport') | translate }}</span>
          } @else {
            <button class="breadcrumb-back" (click)="closeQualite()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              {{ 'site.common.back' | translate }}
            </button>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ 'site.tabs.sat' | translate }}</span>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ 'site.breadcrumb.qualite' | translate }}</span>
          }
        </div>
      </div>
      <div class="satisfaction-subpage">
        <app-qualite #qualiteComp [inline]="true" [forceSingleSite]="true"></app-qualite>
      </div>
    }
    -->

    <!-- Sous-page Satisfaction -->
    @if (showSatisfactionSubpage()) {
      <div class="breadcrumb-bar">
        <button class="breadcrumb-back" (click)="closeSatisfaction()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          {{ 'site.common.back' | translate }}
        </button>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.breadcrumb.fidelisation' | translate }}</span>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.sat.reviews.title' | translate }}</span>
      </div>
      <div class="satisfaction-subpage">
        <app-satisfaction [inline]="true" [initialFeedbackId]="selectedFeedbackId()"></app-satisfaction>
      </div>
    }

    @if (!showSatisfactionSubpage() && !showQualiteSubpage()) {
    <div class="sat-grid">

      <!-- Indicateurs qualité -->
      <div class="card" style="grid-row:1;grid-column:1">
        <div class="flex-jb" style="margin-bottom:14px">
          <div class="ct">{{ 'site.sat.quality.title' | translate }}</div>
        </div>
        <div style="display:flex;gap:20px;align-items:center;margin-bottom:16px">
          <div style="display:flex;flex-direction:column;align-items:center;gap:5px">
            <span style="font-size:48px;font-weight:900;color:var(--ink);line-height:1;letter-spacing:-.04em">{{ formatScore(avgScore()) }}</span>
            <div class="stars">
              @for (filled of starsArray(roundScore(avgScore())); track $index) {
                <svg width="16" height="16" viewBox="0 0 24 24" [attr.fill]="filled ? '#F59E0B' : '#E5E7EB'">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/>
                </svg>
              }
            </div>
            <span style="font-size:11px;color:var(--mu)">{{ totalFeedback() ?? '—' }} {{ 'site.sat.quality.reviewsUnit' | translate }}</span>
          </div>
          <div style="flex:1;display:flex;flex-direction:column;gap:5px">
            <div class="rating-bar"><span class="rating-n">5</span><div class="bar-track"><div class="bar-fill" [style.width]="scoreBarPct(5) + '%'" style="background:#059669"></div></div><span class="rating-pct">{{ scoreBarPct(5) }}%</span></div>
            <div class="rating-bar"><span class="rating-n">4</span><div class="bar-track"><div class="bar-fill" [style.width]="scoreBarPct(4) + '%'" style="background:#059669"></div></div><span class="rating-pct">{{ scoreBarPct(4) }}%</span></div>
            <div class="rating-bar"><span class="rating-n">3</span><div class="bar-track"><div class="bar-fill" [style.width]="scoreBarPct(3) + '%'" style="background:#D97706"></div></div><span class="rating-pct">{{ scoreBarPct(3) }}%</span></div>
            <div class="rating-bar"><span class="rating-n">2</span><div class="bar-track"><div class="bar-fill" [style.width]="scoreBarPct(2) + '%'" style="background:#DC2626"></div></div><span class="rating-pct">{{ scoreBarPct(2) }}%</span></div>
            <div class="rating-bar"><span class="rating-n">1</span><div class="bar-track"><div class="bar-fill" [style.width]="scoreBarPct(1) + '%'" style="background:#DC2626"></div></div><span class="rating-pct">{{ scoreBarPct(1) }}%</span></div>
          </div>
        </div>
        <hr class="divider">
        <div class="flex-jb" style="margin-bottom:10px">
          <div style="font-size:13px;font-weight:700;color:var(--ink)">
            {{ 'site.sat.quality.engagementTitle' | translate }}
            <span class="cs" style="margin-left:8px">{{ qualityPeriodRangeLabel() }}</span>
          </div>
          <div style="display:flex;gap:6px">
            <button class="avis-filter-btn" [class.active]="qualityPeriod() === 'all'" (click)="setQualityPeriod('all')">{{ 'site.sat.quality.periodAll' | translate }}</button>
            <button class="avis-filter-btn" [class.active]="qualityPeriod() === '7d'" (click)="setQualityPeriod('7d')">{{ 'site.sat.quality.period7d' | translate }}</button>
            <button class="avis-filter-btn" [class.active]="qualityPeriod() === '30d'" (click)="setQualityPeriod('30d')">{{ 'site.sat.quality.period30d' | translate }}</button>
          </div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px">
          <div class="engage-card">
            <div class="engage-val">{{ totalQr() ?? '—' }}</div>
            <div class="engage-label">{{ 'site.sat.quality.scansQr' | translate }}</div>
          </div>
          <div class="engage-card">
            <div class="engage-val">{{ formatPct(participationRate()) }}</div>
            <div class="engage-label">{{ 'site.sat.quality.participationRate' | translate }}</div>
          </div>
          <div class="engage-card"><div class="engage-val">{{ googleReviewClicks() ?? '—' }}</div><div class="engage-label">{{ 'site.sat.quality.googleReviews' | translate }}</div></div>
        </div>
        <div style="margin-top:8px;font-size:10px;color:var(--mu)">
          {{ 'site.sat.quality.summarySentence' | translate:{ feedback: (totalFeedback() ?? '—'), scans: (totalQr() ?? '—') } }}
        </div>
      </div>

      <!-- Avis patients -->
      <div class="card" style="grid-row:2;grid-column:1;display:flex;flex-direction:column;max-height:500px">
        <div class="flex-jb" style="margin-bottom:10px">
          <div style="display:flex;align-items:center;gap:8px">
            <div class="ct">{{ 'site.sat.reviews.title' | translate }}</div>
            @if (pendingReplyCount() > 0) {
              <span class="badge o">{{ 'site.sat.reviews.pendingBadge' | translate:{ count: pendingReplyCount() } }}</span>
            }
          </div>
          <div style="display:flex;align-items:center;gap:8px">
            <span style="font-size:11px;color:var(--mu)">{{ filteredAvis().length }} {{ 'site.sat.quality.reviewsUnit' | translate }}</span>
            @if (hasSatisfactionPermission) {
              <button class="btn-primary-sm" (click)="openSatisfaction()">{{ 'site.common.seeMore' | translate }}</button>
            }
          </div>
        </div>
        <div style="display:flex;gap:6px;margin-bottom:12px;flex-wrap:wrap">
          <button class="avis-filter-btn" [class.active]="avisFilter() === 0" (click)="avisFilter.set(0)">{{ 'site.sat.reviews.filterAll' | translate }}</button>
          <button class="avis-filter-btn" [class.active]="avisFilter() === 5" (click)="avisFilter.set(5)">★ 5</button>
          <button class="avis-filter-btn" [class.active]="avisFilter() === 4" (click)="avisFilter.set(4)">★ 4</button>
          <button class="avis-filter-btn" [class.active]="avisFilter() === 3" (click)="avisFilter.set(3)">★ 3</button>
          <button class="avis-filter-btn" [class.active]="avisFilter() === 2" (click)="avisFilter.set(2)">★ 2</button>
          <button class="avis-filter-btn" [class.active]="avisFilter() === 1" (click)="avisFilter.set(1)">★ 1</button>
        </div>
        <div style="flex:1;overflow-y:auto;display:flex;flex-direction:column;gap:8px;padding-right:4px">
          @if (!feedbacksData()) {
            <div style="text-align:center;color:var(--mu);font-size:12px;padding:20px 0">{{ 'site.sat.reviews.loading' | translate }}</div>
          }
          @if (feedbacksData() && filteredAvis().length === 0) {
            <div style="text-align:center;color:var(--mu);font-size:12px;padding:20px 0">{{ 'site.sat.reviews.noneForFilter' | translate }}</div>
          }
          @for (avis of filteredAvis(); track avis.feedback_id) {
            <div class="avis-item" style="cursor:pointer" (click)="openSatisfaction(avis.feedback_id)">
              <div class="avis-head">
                <div class="stars">
                  @for (filled of starsArray(avis.score); track $index) {
                    <svg width="12" height="12" viewBox="0 0 24 24" [attr.fill]="filled ? '#F59E0B' : '#E5E7EB'">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/>
                    </svg>
                  }
                </div>
                <span class="avis-time">{{ formatAvisDate(avis.created_at) }}</span>
              </div>
              @if (avis.queue_name || avis.reported_bucket) {
                <div class="avis-tags">
                  @if (avis.queue_name) { <span class="skill">{{ avis.queue_name }}</span> }
                  @if (bucketBadge(avis.reported_bucket); as badge) {
                    <span style="font-size:10px;color:var(--mu)">{{ 'site.sat.reviews.waitPerceptionLabel' | translate }}</span>
                    <span [class]="'badge ' + badge.cls" style="font-size:9px">{{ badge.label }}</span>
                  }
                </div>
              }
              @if (avis.comment) {
                <div class="avis-text">{{ avis.comment }}</div>
              }
            </div>
          }
        </div>
      </div>

      <!-- Taux de satisfaction -->
      <div class="card" style="grid-row:1;grid-column:2">
        <div class="flex-jb" style="margin-bottom:4px">
          <div class="ct">{{ 'site.sat.chart.title' | translate }}</div>
          <div class="cs">{{ 'site.sat.chart.subtitle' | translate }}</div>
        </div>
        <div style="margin-top:14px">
          @if (!hasSatisfactionHistory()) {
            <div style="text-align:center;color:var(--mu);font-size:12px;padding:60px 0">{{ 'site.sat.chart.notEnoughData' | translate }}</div>
          } @else {
          <svg viewBox="0 0 520 230" width="100%" height="230" style="display:block;font-family:inherit">
            <rect x="45" y="10" width="440" height="180" rx="6" fill="#faf9fd"/>
            <line x1="45" x2="485" y1="50" y2="50" stroke="#e6e0f2" stroke-width="0.5"/>
            <line x1="45" x2="485" y1="90" y2="90" stroke="#e6e0f2" stroke-width="0.5"/>
            <line x1="45" x2="485" y1="130" y2="130" stroke="#e6e0f2" stroke-width="0.5"/>
            <line x1="45" x2="485" y1="170" y2="170" stroke="#e6e0f2" stroke-width="0.5"/>
            <text x="38" y="14" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">100%</text>
            <text x="38" y="53" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">75%</text>
            <text x="38" y="93" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">50%</text>
            <text x="38" y="133" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">25%</text>
            <text x="38" y="173" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">0%</text>
            @for (label of satisfactionChartLabels(); track $index) {
              <text [attr.x]="satisfactionChartPoints()[$index].x" y="205" font-size="10" fill="#72788C" text-anchor="middle" font-weight="700">{{ label }}</text>
            }
            <polyline [attr.points]="satisfactionChartPolyline()" fill="none" stroke="#7B5FD4" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            @for (point of satisfactionChartPoints(); track $index) {
              @if (point.y != null) {
                <circle [attr.cx]="point.x" [attr.cy]="point.y" r="4.5" fill="#7B5FD4"/>
                <text [attr.x]="point.x" [attr.y]="point.y - 10" font-size="9" fill="#7B5FD4" text-anchor="middle" font-weight="700">{{ point.pct }}%</text>
              }
            }
          </svg>
          }
        </div>
      </div>

      <!-- Notes par statut d'attente -->
      <div class="card" style="grid-row:2;grid-column:2;align-self:start">
        <div class="ct" style="margin-bottom:4px">{{ 'site.sat.byStatus.title' | translate }}</div>
        <div class="cs" style="margin-bottom:10px">{{ 'site.sat.byStatus.subtitle' | translate }}</div>
        @if (!waitStatusStats() || waitStatusStats()!.total === 0) {
          <div style="text-align:center;color:var(--mu);font-size:12px;padding:20px 0">{{ 'site.sat.chart.notEnoughData' | translate }}</div>
        } @else {
        <div style="display:flex;flex-direction:column;gap:10px">
          <div class="statut-row" style="background:#f0fdf4;border:1px solid rgba(21,151,107,.2)">
            <div class="statut-label"><span class="statut-dot" style="background:var(--gn)"></span><span style="color:var(--gn)">{{ 'site.sat.byStatus.fluide' | translate }}</span></div>
            <div class="statut-bar"><div class="statut-bar-fill" [style.width.%]="waitStatusStats()!.fluide.pct" style="background:var(--gn)"></div></div>
            <div style="min-width:50px;text-align:right"><span style="font-size:14px;font-weight:900;color:var(--gn)">{{ waitStatusStats()!.fluide.count }}</span><span style="font-size:10px;color:var(--mu)"> {{ 'site.sat.quality.reviewsUnit' | translate }}</span></div>
            <div style="min-width:50px;text-align:right;display:flex;align-items:center;gap:3px;justify-content:flex-end">
              @if (waitStatusStats()!.fluide.avg != null) {
                <svg width="11" height="11" viewBox="0 0 24 24" fill="#F59E0B"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg><span style="font-size:13px;font-weight:900;color:var(--ink)">{{ waitStatusStats()!.fluide.avg | number:'1.1-1' }}</span>
              } @else { <span style="font-size:12px;color:var(--mu)">—</span> }
            </div>
          </div>
          <div class="statut-row" style="background:#fffbeb;border:1px solid rgba(194,115,0,.2)">
            <div class="statut-label"><span class="statut-dot" style="background:var(--or)"></span><span style="color:var(--or)">{{ 'site.sat.byStatus.modere' | translate }}</span></div>
            <div class="statut-bar"><div class="statut-bar-fill" [style.width.%]="waitStatusStats()!.tension.pct" style="background:var(--or)"></div></div>
            <div style="min-width:50px;text-align:right"><span style="font-size:14px;font-weight:900;color:var(--or)">{{ waitStatusStats()!.tension.count }}</span><span style="font-size:10px;color:var(--mu)"> {{ 'site.sat.quality.reviewsUnit' | translate }}</span></div>
            <div style="min-width:50px;text-align:right;display:flex;align-items:center;gap:3px;justify-content:flex-end">
              @if (waitStatusStats()!.tension.avg != null) {
                <svg width="11" height="11" viewBox="0 0 24 24" fill="#F59E0B"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg><span style="font-size:13px;font-weight:900;color:var(--ink)">{{ waitStatusStats()!.tension.avg | number:'1.1-1' }}</span>
              } @else { <span style="font-size:12px;color:var(--mu)">—</span> }
            </div>
          </div>
          <div class="statut-row" style="background:#fef2f2;border:1px solid rgba(217,54,65,.2)">
            <div class="statut-label"><span class="statut-dot" style="background:var(--rd)"></span><span style="color:var(--rd)">{{ 'site.sat.byStatus.critique' | translate }}</span></div>
            <div class="statut-bar"><div class="statut-bar-fill" [style.width.%]="waitStatusStats()!.critique.pct" style="background:var(--rd)"></div></div>
            <div style="min-width:50px;text-align:right"><span style="font-size:14px;font-weight:900;color:var(--rd)">{{ waitStatusStats()!.critique.count }}</span><span style="font-size:10px;color:var(--mu)"> {{ 'site.sat.quality.reviewsUnit' | translate }}</span></div>
            <div style="min-width:50px;text-align:right;display:flex;align-items:center;gap:3px;justify-content:flex-end">
              @if (waitStatusStats()!.critique.avg != null) {
                <svg width="11" height="11" viewBox="0 0 24 24" fill="#F59E0B"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg><span style="font-size:13px;font-weight:900;color:var(--ink)">{{ waitStatusStats()!.critique.avg | number:'1.1-1' }}</span>
              } @else { <span style="font-size:12px;color:var(--mu)">—</span> }
            </div>
          </div>
        </div>
        <div style="margin-top:8px;font-size:10px;color:var(--mu)">
          {{ 'site.sat.byStatus.totalSentence' | translate:{ count: waitStatusStats()!.total } }}
          @if (waitStatusStats()!.delta != null) {
            · {{ waitStatusStats()!.delta! >= 0 ? '+' : '' }}{{ waitStatusStats()!.delta | number:'1.1-1' }} {{ 'site.sat.byStatus.deltaSuffix' | translate }}
          }
        </div>
        }
      </div>

    </div>
    }
  }

  <!-- ════════════════════════════════════════ PRÉVENTION ════ -->
  @if (activeTab() === 'prevention') {

    <!-- Sous-page Activité -->
    @if (showPreventionActivitySubpage()) {
      <div class="breadcrumb-bar">
        <button class="breadcrumb-back" (click)="closePreventionActivity()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          {{ 'site.common.back' | translate }}
        </button>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.tabs.prevention' | translate }}</span>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.prevention.activity.subpageTitle' | translate }}</span>
      </div>
      <div class="satisfaction-subpage">
        <div class="card">
          @if (activityTotal() > 0) {
            <div class="cs" style="margin-bottom:10px">{{ 'site.prevention.activity.totalSentence' | translate:{ count: activityTotal() } }}</div>
          }
          <div style="display:flex;flex-direction:column">
            @for (item of activityItems(); track item.opportunityId) {
              <div class="flex-jb" style="padding:10px 0;border-bottom:1px solid var(--bd)">
                <div>
                  <div style="font-size:13px;font-weight:600;color:var(--ink)">{{ item.offerName }}@if (item.source === 'CONTEXTUAL_OFFER') {<span data-testid="activity-contextual-badge" style="display:inline-block;margin-left:6px;padding:1px 7px;border-radius:9px;background:rgba(255,184,0,.16);color:#7a5600;font-size:11px;font-weight:700;vertical-align:middle">{{ 'site.prevention.activity.contextualBadge' | translate }}</span>}</div>
                  <div class="cs">{{ formatPreventionDate(item.interestAt) }}</div>
                  @if (patientIdentityLabel(item); as identity) {
                    <div class="cs" data-testid="activity-patient-identity" style="color:var(--ink)">{{ identity }} · {{ 'site.prevention.activity.declaredIdentity' | translate }}</div>
                  }
                </div>
                <div style="font-size:13px;font-weight:700;color:var(--ink)">{{ formatPreventionPrice(item.price, item.currency) }}</div>
              </div>
            }
            @if (activityItems().length === 0 && !activityLoading()) {
              <div class="cs" style="text-align:center;padding:20px 0">{{ 'site.prevention.activity.empty' | translate }}</div>
            }
          </div>
          @if (activityHasMore()) {
            <div style="text-align:center;margin-top:14px">
              <button class="btn-primary-sm" [disabled]="activityLoading()" (click)="loadMoreActivity()">
                {{ (activityLoading() ? 'common.actions.loading' : 'site.prevention.activity.loadMore') | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    }

    <!-- Sous-page Configuration -->
    @if (showPreventionCatalogSubpage()) {
      <div class="breadcrumb-bar">
        <button class="breadcrumb-back" (click)="showOfferFormSubpage() ? closeOfferFormSubpage() : (showAddOfferSubpage() ? closeAddOfferSubpage() : closePreventionCatalog())">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          {{ 'site.common.back' | translate }}
        </button>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current" [class.breadcrumb-link]="showAddOfferSubpage() || showOfferFormSubpage()" (click)="(showAddOfferSubpage() || showOfferFormSubpage()) && closePreventionCatalog()">{{ 'site.tabs.prevention' | translate }}</span>
        <span class="breadcrumb-sep">·</span>
        @if (showOfferFormSubpage()) {
          <span class="breadcrumb-current breadcrumb-link" (click)="closeAddOfferSubpage()">{{ 'site.prevention.offer.subpageTitle' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current breadcrumb-link" (click)="closeOfferFormSubpage()">{{ 'site.prevention.offer.addOfferPage.breadcrumb' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ configuringOfferName() ?? ('preventionOffres.offerForm.createBreadcrumb' | translate) }}</span>
        } @else if (showAddOfferSubpage()) {
          <span class="breadcrumb-current breadcrumb-link" (click)="closeAddOfferSubpage()">{{ 'site.prevention.offer.subpageTitle' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.prevention.offer.addOfferPage.breadcrumb' | translate }}</span>
        } @else {
          <span class="breadcrumb-current">{{ 'site.prevention.offer.subpageTitle' | translate }}</span>
        }
      </div>
      @if (showOfferFormSubpage()) {
        <div class="satisfaction-subpage">
          <app-offer-form-page [embedded]="true" [offerIdOverride]="configuringOfferId()" [fromTemplateOverride]="creatingFromTemplateCode()" [readOnly]="formReadOnly()" (back)="closeOfferFormSubpage()" (created)="onOfferCreated($event)"></app-offer-form-page>
        </div>
      } @else if (showAddOfferSubpage()) {
        <div class="satisfaction-subpage">
          <app-prevention-site-add-offer [offers]="preventionCatalog() ?? []" (activateOffer)="onActivateOfferForCurrentSite($event)" (viewDetails)="openOfferDetails($event)" (createOffer)="openCreateOfferFormBlank()" (back)="closeAddOfferSubpage()"></app-prevention-site-add-offer>
        </div>
      } @else {
      <div class="satisfaction-subpage">
        <div class="card" style="margin-bottom:16px">
          <div class="ct" style="margin-bottom:6px">{{ 'site.prevention.contact.title' | translate }}</div>
          <div class="cs" style="margin-bottom:6px">{{ 'site.prevention.contact.subtitle' | translate }}</div>
          <div class="cs" style="margin-bottom:14px;display:flex;align-items:center;gap:6px;flex-wrap:wrap">
            <span class="badge p">{{ 'site.prevention.contact.defaultBadge' | translate }}</span>
            {{ 'site.prevention.contact.defaultOverrideNote' | translate }}
          </div>
          <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">
            <select class="select-ctrl" [value]="contactRoleDraft() ?? ''" (change)="onContactRoleChanged($any($event.target).value)">
              <option value="">{{ 'site.prevention.contact.notConfigured' | translate }}</option>
              <option value="ACCUEIL">{{ 'site.prevention.contact.roles.ACCUEIL' | translate }}</option>
              <option value="PRELEVEUR">{{ 'site.prevention.contact.roles.PRELEVEUR' | translate }}</option>
              <option value="BIOLOGISTE">{{ 'site.prevention.contact.roles.BIOLOGISTE' | translate }}</option>
              <option value="AUTRE">{{ 'site.prevention.contact.roles.AUTRE' | translate }}</option>
            </select>
            @if (contactRoleDirty()) {
              <button class="btn-ps-sm" (click)="saveContactRole()" [disabled]="savingContactRole() || contactSaveBlocked()">
                {{ (savingContactRole() ? 'site.prevention.offer.saving' : 'site.prevention.offer.save') | translate }}
              </button>
            }
          </div>
          @if (showReturnToReception()) {
            <label class="return-reception" style="display:flex;align-items:flex-start;gap:10px;margin-top:14px;cursor:pointer">
              <input type="checkbox" style="margin-top:3px;width:16px;height:16px;flex:none;cursor:pointer"
                [checked]="returnToReceptionDraft()" (change)="onReturnToReceptionChanged($any($event.target).checked)">
              <span style="display:flex;flex-direction:column;gap:2px">
                <span style="font-size:13px;font-weight:600">{{ 'site.prevention.contact.returnToReception' | translate }}</span>
                <span class="cs">{{ 'site.prevention.contact.returnToReceptionSub' | translate }}</span>
              </span>
            </label>
          }
          <div class="identity-setting" style="margin-top:16px;padding-top:14px;border-top:1px solid var(--bd);display:flex;flex-direction:column;gap:6px">
            <label for="identityOnSite" style="font-size:13px;font-weight:600">{{ 'site.prevention.contact.identityTitle' | translate }}</label>
            <span class="cs">{{ 'site.prevention.contact.identitySub' | translate }}</span>
            <select id="identityOnSite" class="select-ctrl" style="align-self:flex-start" [value]="identityModeDraft()" (change)="onIdentityModeChanged($any($event.target).value)">
              <option value="NONE">{{ 'site.prevention.contact.identityModes.NONE' | translate }}</option>
              <option value="OPTIONAL">{{ 'site.prevention.contact.identityModes.OPTIONAL' | translate }}</option>
              <option value="REQUIRED">{{ 'site.prevention.contact.identityModes.REQUIRED' | translate }}</option>
            </select>
            @if (identityModeDraft() !== 'NONE') {
              <span class="cs" role="note" style="color:#7a5600">{{ 'site.prevention.contact.identityWarning' | translate }}</span>
            }
            @if (identityAttestationNeeded()) {
              <label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer">
                <input type="checkbox" style="margin-top:3px;width:16px;height:16px;flex:none;cursor:pointer"
                  [checked]="identityAttestationDraft()" (change)="identityAttestationDraft.set($any($event.target).checked)">
                <span style="font-size:13px;font-weight:600">{{ 'site.prevention.contact.identityAttestation' | translate }}</span>
              </label>
            }
          </div>
        </div>
        <div class="flex-jb" style="margin:4px 0 12px">
          <div class="ct">{{ 'site.prevention.offer.listTitle' | translate }}</div>
          <button (click)="openAddOffer()" style="display:inline-flex;align-items:center;gap:6px;padding:7px 16px;border-radius:10px;background:var(--p);color:#fff;border:none;font-size:13px;font-weight:700;cursor:pointer;white-space:nowrap">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
            {{ 'site.prevention.offer.addOfferCta' | translate }}
          </button>
        </div>
        @for (offer of offersToShowInSiteList(); track offer.offerId) {
          <div class="card" style="margin-bottom:16px">
            @if (editingOfferId() === offer.offerId) {
              <div style="display:flex;flex-direction:column;gap:12px">
                <div style="font-size:13px;font-weight:700;color:var(--ink)">{{ offer.name }}</div>
                <div class="toggle-row-item" (click)="editOfferActive.set(!editOfferActive())" style="cursor:pointer">
                  <div>
                    <div class="toggle-label">{{ 'site.prevention.offer.active' | translate }}</div>
                    <div class="toggle-sub">{{ 'site.prevention.offer.activeSub' | translate }}</div>
                  </div>
                  <div [class]="editOfferActive() ? 'toggle-on' : 'toggle-off'"></div>
                </div>
                <div style="display:flex;gap:10px">
                  <div style="flex:1">
                    <label class="toggle-label" style="display:block;margin-bottom:4px">{{ 'site.prevention.offer.price' | translate }}</label>
                    <input class="input" type="text" inputmode="decimal"
                           [value]="editOfferPrice() ?? ''"
                           (input)="onEditOfferPriceInput($any($event.target).value)"
                           placeholder="18.00">
                  </div>
                  <div>
                    <label class="toggle-label" style="display:block;margin-bottom:4px">{{ 'site.prevention.offer.currency' | translate }}</label>
                    <select class="select-ctrl" [value]="editOfferCurrency()" (change)="onEditOfferCurrencyChanged($any($event.target).value)">
                      @for (c of offerSiteCurrencies; track c) {
                        <option [value]="c">{{ c }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="toggle-row-item" (click)="editOfferFeasible.set(!editOfferFeasible())" style="cursor:pointer">
                  <div>
                    <div class="toggle-label">{{ 'site.prevention.offer.immediateFeasibility' | translate }}</div>
                    <div class="toggle-sub">{{ 'site.prevention.offer.immediateFeasibilitySub' | translate }}</div>
                  </div>
                  <div [class]="editOfferFeasible() ? 'toggle-on' : 'toggle-off'"></div>
                </div>
                <div>
                  <label class="toggle-label" style="display:block;margin-bottom:4px">{{ 'site.prevention.offer.conditions' | translate }}</label>
                  <textarea class="textarea-ctrl" rows="2"
                            [value]="editOfferConditions()"
                            (input)="editOfferConditions.set($any($event.target).value)"
                            [placeholder]="'site.prevention.offer.conditionsPlaceholder' | translate"></textarea>
                  <div class="cs" style="margin-top:4px">{{ 'site.prevention.offer.conditionsHelp' | translate }}</div>
                </div>
                <div>
                  <label class="toggle-label" style="display:block;margin-bottom:4px">{{ 'site.prevention.contact.title' | translate }}</label>
                  <select class="select-ctrl" [value]="editOfferContactRole() ?? ''" (change)="onEditOfferContactRoleChanged($any($event.target).value)">
                    <option value="">{{ 'site.prevention.offer.contactRoleDefaultOption' | translate }}</option>
                    <option value="ACCUEIL">{{ 'site.prevention.contact.roles.ACCUEIL' | translate }}</option>
                    <option value="PRELEVEUR">{{ 'site.prevention.contact.roles.PRELEVEUR' | translate }}</option>
                    <option value="BIOLOGISTE">{{ 'site.prevention.contact.roles.BIOLOGISTE' | translate }}</option>
                    <option value="AUTRE">{{ 'site.prevention.contact.roles.AUTRE' | translate }}</option>
                  </select>
                  @if (editOfferContactRole() === null) {
                    <div class="cs" style="margin-top:4px">
                      {{ siteDefaultContactRoleDisplay() }}
                    </div>
                  }
                </div>
                @if (offer.hasDuplicateCoverage) {
                  <div class="toggle-row-item" (click)="onToggleEditOfferCommercialPreference()" style="cursor:pointer">
                    <div>
                      <div class="toggle-label">{{ 'site.prevention.offer.commercialPreference' | translate }}</div>
                      <div class="toggle-sub">{{ 'site.prevention.offer.commercialPreferenceSub' | translate }}</div>
                    </div>
                    <div [class]="editOfferCommercialPreference() ? 'toggle-on' : 'toggle-off'"></div>
                  </div>
                }
                <div style="display:flex;gap:8px;justify-content:flex-end">
                  <button class="btn-danger-sm" (click)="cancelEditOffer()" [disabled]="savingOffer()">{{ 'site.common.cancel' | translate }}</button>
                  <button class="btn-ps-sm" (click)="saveOffer()" [disabled]="savingOffer()">
                    {{ (savingOffer() ? 'site.prevention.offer.saving' : 'site.prevention.offer.save') | translate }}
                  </button>
                </div>
              </div>
            } @else {
              <div style="display:flex;align-items:center;gap:20px;margin:-20px 0 -20px -20px">
                <div (click)="startEditOffer(offer)" style="cursor:pointer;flex:1;min-width:0;display:flex;gap:14px">
                  @if (offer.hasPhoto) {
                    <img [src]="getOfferPhotoUrl(offer)" [attr.alt]="offer.name" style="aspect-ratio:16/9;min-height:84px;max-height:160px;border-radius:14px 0 0 14px;object-fit:cover;object-position:center;background:#fff;flex-shrink:0;align-self:stretch">
                  } @else {
                    <div style="aspect-ratio:16/9;min-height:84px;max-height:160px;border-radius:14px 0 0 14px;background:linear-gradient(135deg,var(--ps),#fff);display:flex;align-items:center;justify-content:center;flex-shrink:0;align-self:stretch">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--p)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.65"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                    </div>
                  }
                  <div style="flex:1;min-width:0;padding:20px 8px 20px 0;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap">
                    <div>
                      <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--p)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><path d="M12.5 20.3c-.3.2-.7.2-1 0C7.6 17.8 3.4 14.2 3.4 9.9 3.4 7.1 5.5 5.2 8 5.2c1.4 0 2.7.7 3.6 1.8.9-1.1 2.2-1.8 3.6-1.8 2.5 0 4.6 1.9 4.6 4.7 0 4.3-4.2 7.9-8.3 10.4z"/><path d="M5.2 12.2h2.6l1.4-2.8 1.9 4.6 1.4-2.8h6.3"/></svg>
                        <span style="font-size:13px;font-weight:600;color:var(--ink)">{{ offer.name }}</span>
                      </div>
                      <div class="cs" style="margin-left:20px">{{ bilanNames(offer) }}</div>
                      <div class="cs" style="margin-left:20px;margin-top:2px">
                        {{ offer.patientContactRole ? contactRoleLabel(offer.patientContactRole) : siteDefaultContactRoleDisplay() }}
                      </div>
                    </div>
                    <div style="text-align:right;flex-shrink:0">
                      <span class="cs">{{ 'site.prevention.offer.statusActive' | translate }}</span>
                      <div style="font-size:13px;font-weight:700;color:var(--ink);margin-top:2px">{{ formatPreventionPrice(offer.price, offer.currency) }}</div>
                      <div style="margin-top:14px">
                        <button class="btn-ps-sm">{{ 'site.prevention.offer.configure' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <button type="button"
                        class="offer-delete-btn"
                        [attr.aria-label]="'site.prevention.offer.removeIconLabel' | translate"
                        [attr.title]="'site.prevention.offer.removeIconLabel' | translate"
                        (click)="openRemoveOfferConfirm(offer, $event)">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--rd)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
                </button>
              </div>
            }
          </div>
        }
        @if (preventionCatalog() && preventionCatalog()!.length === 0) {
          <div class="card"><div class="cs" style="text-align:center;padding:20px 0">{{ 'site.prevention.offer.empty' | translate }}</div></div>
        } @else if (offersToShowInSiteList().length === 0) {
          <div class="card"><div class="cs" style="text-align:center;padding:20px 0">{{ 'site.prevention.offer.noActiveOffers' | translate }}</div></div>
        }
      </div>
      }
    }

    <!-- Sous-page Parcours patient (analytics, Lot 6) -->
    @if (showPreventionJourneySubpage()) {
      <div class="breadcrumb-bar">
        <button class="breadcrumb-back" (click)="closePreventionJourney()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          {{ 'site.common.back' | translate }}
        </button>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.tabs.prevention' | translate }}</span>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.prevention.journey.subpageTitle' | translate }}</span>
      </div>
      <div class="satisfaction-subpage">

        <div style="display:flex;gap:8px;margin-bottom:16px">
          @for (d of [7, 30, 90]; track d) {
            <button class="period-btn" [class.active]="preventionPeriodDays() === d" (click)="setPreventionPeriodDays(d)">
              {{ 'site.prevention.period.' + d | translate }}
            </button>
          }
        </div>

        <!-- Exposition (hors cohorte) séparée du Parcours des participants (funnel réel) -- évite de lire
             "Affichages -> Démarrages" comme une conversion (audit d'harmonisation 2026-08-29, Lot 9.0-E.E.F.1) -->
        <div class="card" style="margin-bottom:16px">
          <div class="ct" style="margin-bottom:4px">{{ 'site.prevention.journey.exposureTitle' | translate }}</div>
          <div style="font-size:26px;font-weight:900;color:var(--mu);margin-bottom:2px">{{ preventionFunnelAnalytics()?.exposed ?? '—' }}</div>
          <div class="cs">{{ 'site.prevention.journey.exposed' | translate }}</div>

          <hr class="divider" style="margin:16px 0 14px">

          <div class="ct" style="margin-bottom:4px">{{ 'site.prevention.journey.participantsTitle' | translate }}</div>
          <div class="cs" style="margin-bottom:10px">{{ 'site.prevention.journey.funnelSubtitle' | translate }}</div>
          <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap">
            <div class="engage-card" style="flex:1;min-width:110px"><div class="engage-val">@if (preventionFunnelWithheld()) {
<span class="cs" data-testid="funnel-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
} @else {
{{ preventionFunnelAnalytics()?.started ?? '—' }}
}</div><div class="engage-label">{{ 'site.prevention.journey.started' | translate }}</div></div>
            <span class="cs">→</span>
            <div class="engage-card" style="flex:1;min-width:110px"><div class="engage-val">@if (preventionFunnelWithheld()) {
<span class="cs" data-testid="funnel-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
} @else {
{{ preventionFunnelAnalytics()?.completed ?? '—' }}
}</div><div class="engage-label">{{ 'site.prevention.journey.completed' | translate }}</div></div>
            <span class="cs">→</span>
            <div class="engage-card" style="flex:1;min-width:110px"><div class="engage-val">{{ preventionFunnelAnalytics()?.recommendationReached ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.recommendationReached' | translate }}</div></div>
            <span class="cs">→</span>
            <div class="engage-card" style="flex:1;min-width:110px;background:rgba(255,43,152,.06);border-color:rgba(255,43,152,.25)"><div class="engage-val" style="color:var(--a)">{{ preventionFunnelAnalytics()?.interested ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.interested' | translate }}</div></div>
          </div>
          <div style="display:flex;gap:24px;margin-top:14px">
            <div class="flex-jb" style="flex:1">
              <span class="cs">{{ 'site.prevention.journey.completionRate' | translate }}</span>
              @if (preventionFunnelWithheld()) {
<span class="cs" data-testid="funnel-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
} @else {
<span style="font-size:14px;font-weight:800;color:var(--ink)">{{ formatPreventionRate($safeNavigationMigration(preventionFunnelAnalytics()?.completionRate)) }}</span>
}
            </div>
            <div class="flex-jb" style="flex:1">
              <span class="cs">{{ 'site.prevention.journey.interestRate' | translate }}</span>
              <span style="font-size:14px;font-weight:800;color:var(--ink)">{{ formatPreventionRate($safeNavigationMigration(preventionFunnelAnalytics()?.interestRate)) }}</span>
            </div>
          </div>

          <!-- Refonte « Votre résultat » (2026-10-16) : décisions détaillées et écran du « oui ». -->
          <hr class="divider" style="margin:16px 0 14px">
          <div class="ct" style="margin-bottom:4px">{{ 'site.prevention.journey.decisions.title' | translate }}</div>
          <div class="cs" style="margin-bottom:10px">{{ 'site.prevention.journey.decisions.subtitle' | translate }}</div>
          <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:8px" data-testid="journey-decisions">
            <div class="engage-card"><div class="engage-val">{{ preventionFunnelAnalytics()?.engaged ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.decisions.engaged' | translate }}</div></div>
            <div class="engage-card"><div class="engage-val">{{ preventionFunnelAnalytics()?.later ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.decisions.later' | translate: { converted: preventionFunnelAnalytics()?.laterConverted ?? 0 } }}</div></div>
            <div class="engage-card"><div class="engage-val">{{ preventionFunnelAnalytics()?.declined ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.decisions.declined' | translate }}</div></div>
            <div class="engage-card"><div class="engage-val">{{ preventionFunnelAnalytics()?.contextualInterested ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.decisions.contextualInterested' | translate }}</div></div>
          </div>
          <div style="font-size:13px;font-weight:700;color:var(--ink);margin:14px 0 8px">{{ 'site.prevention.journey.decisions.originTitle' | translate }}</div>
          <div style="display:flex;flex-direction:column;gap:6px" data-testid="journey-origins">
            @for (o of preventionDecisionOrigins(); track o.key) {
              <div class="flex-jb"><span class="cs">{{ 'site.prevention.journey.decisions.origin.' + o.key | translate }}</span><span style="font-size:14px;font-weight:800;color:var(--ink)">{{ o.count }}</span></div>
            }
          </div>
        </div>

        <!-- Résultat des questionnaires terminés -->
        <div class="card" style="margin-bottom:16px">
          <div class="ct" style="margin-bottom:14px">{{ 'site.prevention.journey.outcomes.title' | translate }}</div>
          <div style="display:flex;flex-direction:column;gap:10px">
            @if (preventionFunnelWithheld()) {
              <div class="cs" style="text-align:center;padding:10px 0" data-testid="outcomes-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</div>
            } @else {
            @for (outcome of preventionFunnelAnalytics()?.outcomes ?? []; track outcome.kind) {
              <div class="statut-row" [style.background]="outcomeKindTint[outcome.kind]?.bg" [style.border]="outcomeKindTint[outcome.kind]?.border">
                <div class="statut-label" style="min-width:160px">
                  <span class="statut-dot" [style.background]="outcomeKindTint[outcome.kind]?.color"></span>
                  <span [style.color]="outcomeKindTint[outcome.kind]?.color">{{ outcomeKindLabelKeys[outcome.kind] | translate }}</span>
                </div>
                <div class="statut-bar"><div class="statut-bar-fill" [style.width.%]="outcomePct(outcome.count)" [style.background]="outcomeKindTint[outcome.kind]?.color"></div></div>
                <div style="min-width:36px;text-align:right">
                  <span style="font-size:14px;font-weight:900" [style.color]="outcomeKindTint[outcome.kind]?.color">{{ outcome.count }}</span>
                </div>
              </div>
            }
            @if ((preventionFunnelAnalytics()?.outcomes ?? []).length === 0) {
              <div class="cs" style="text-align:center;padding:10px 0">{{ 'site.prevention.journey.outcomes.empty' | translate }}</div>
            }
            }
          </div>
        </div>

        <!-- Abandons -- restreint à la version de questionnaire actuellement active, jamais mélangé avec une ancienne version -->
        <div class="card" style="margin-bottom:16px">
          <div class="ct" style="margin-bottom:4px">{{ 'site.prevention.journey.abandonment.title' | translate }}</div>
          <div class="cs" style="margin-bottom:2px">{{ 'site.prevention.journey.abandonment.currentVersionNote' | translate }}</div>
          <div class="cs" style="margin-bottom:14px">{{ 'site.prevention.journey.abandonment.beforeOfferNote' | translate }}</div>
          @if ((preventionFunnelAnalytics()?.abandonment ?? []).length > 0) {
            <div style="display:flex;flex-direction:column;gap:8px">
              @for (bucket of preventionFunnelAnalytics()?.abandonment ?? []; track $index) {
                <div class="flex-jb">
                  <span class="cs">{{ bucket.moduleCode === 'SENSITIVE_MODULE' ? ('site.prevention.journey.abandonment.sensitiveStep' | translate) : bucket.position === 0 ? ('site.prevention.journey.abandonment.beforeFirstQuestion' | translate) : (bucket.questionText ?? (bucket.rank !== null ? ('site.prevention.journey.abandonment.afterQuestion' | translate:{ rank: bucket.rank }) : ('site.prevention.journey.abandonment.afterQuestionUnknownRank' | translate))) }}</span>
                  @if (bucket.insufficientData) {
                    <span class="cs">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
                  } @else {
                    <span style="font-size:13px;font-weight:700;color:var(--ink)">{{ bucket.count }}</span>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="cs" style="text-align:center;padding:10px 0">{{ 'site.prevention.journey.abandonment.empty' | translate }}</div>
          }
        </div>

      </div>
    }

    <!-- Sous-page Performance & impact (analytics, Lot 6) -->
    @if (showPreventionPerformanceSubpage()) {
      <div class="breadcrumb-bar">
        @if (preventionOfferDetail(); as detail) {
          <button class="breadcrumb-back" (click)="closeOfferDetail()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current breadcrumb-link" (click)="closeOfferDetail()">{{ 'site.prevention.performance.subpageTitle' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ detail.offerName }}</span>
        } @else {
          <button class="breadcrumb-back" (click)="closePreventionPerformance()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.tabs.prevention' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.prevention.performance.subpageTitle' | translate }}</span>
        }
      </div>
      <div class="satisfaction-subpage">

        @if (preventionOfferDetailLoading()) {
          <div class="card"><div class="cs" style="text-align:center;padding:20px 0">{{ 'common.actions.loading' | translate }}</div></div>
        } @else if (preventionOfferDetail(); as detail) {

          <!-- Drill-down d'une offre -->
          <div class="card" style="margin-bottom:16px">
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">
              <div class="engage-card"><div class="engage-val">{{ detail.recommendationsDisplayed }}</div><div class="engage-label">{{ 'site.prevention.journey.recommendationsDisplayed' | translate }}</div></div>
              <div class="engage-card"><div class="engage-val">{{ detail.recommendationReached }}</div><div class="engage-label">{{ 'site.prevention.journey.recommendationReached' | translate }}</div></div>
              <div class="engage-card" style="background:rgba(255,43,152,.06);border-color:rgba(255,43,152,.25)"><div class="engage-val" style="color:var(--a)">{{ detail.interested }}</div><div class="engage-label">{{ 'site.prevention.journey.interested' | translate }}</div></div>
              <div class="engage-card"><div class="engage-val">{{ formatPreventionRate(detail.interestRate) }}</div><div class="engage-label">{{ 'site.prevention.journey.interestRate' | translate }}</div></div>
            </div>
            <hr class="divider">
            <div class="flex-jb">
              <span class="cs">{{ 'site.prevention.performance.opportunities' | translate }}</span>
              <span style="font-size:14px;font-weight:800;color:var(--a)">{{ detail.opportunities }}</span>
            </div>
            <div class="flex-jb" style="margin-top:8px">
              <span class="cs">{{ 'site.prevention.performance.opportunitiesValue' | translate }}</span>
              <span style="font-size:14px;font-weight:800;color:var(--a)">{{ formatPreventionPrice(detail.opportunityValue, detail.currency) }}</span>
            </div>
          </div>

          <div class="card">
            <div class="ct" style="margin-bottom:12px">{{ 'site.prevention.journey.timeline.title' | translate }}</div>
            @if (detail.timeline.length > 0) {
              <svg width="100%" height="92" viewBox="0 0 320 92" preserveAspectRatio="none" style="display:block;font-family:inherit">
                <rect x="34" y="6" width="280" height="70" rx="4" fill="#fff5fa"/>
                <line x1="34" x2="314" y1="6" y2="6" stroke="#f9dcec" stroke-width="0.5"/>
                <line x1="34" x2="314" y1="41" y2="41" stroke="#f9dcec" stroke-width="0.5"/>
                <line x1="34" x2="314" y1="76" y2="76" stroke="#f9dcec" stroke-width="0.5"/>
                <text x="30" y="10" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">{{ offerDetailTimelineMax() }}</text>
                <text x="30" y="79" font-size="9" fill="#72788C" text-anchor="end" font-weight="700">0</text>
                <g transform="translate(34,6)">
                  <polyline [attr.points]="offerDetailTimelinePoints()" fill="none" stroke="var(--a)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  @if (offerDetailTimelineData().last; as last) {
                    <circle [attr.cx]="last.x" [attr.cy]="last.y" r="3.5" fill="var(--a)"/>
                    <text [attr.x]="last.x" [attr.y]="last.y - 8" font-size="9" fill="var(--a)" text-anchor="end" font-weight="700">{{ last.value }}</text>
                  }
                </g>
              </svg>
            } @else {
              <div class="cs" style="text-align:center;padding:10px 0">{{ 'site.prevention.journey.timeline.empty' | translate }}</div>
            }
          </div>

        } @else {

          <!-- Liste : top KPIs + table par offre -->
          <div style="display:flex;gap:8px;margin-bottom:16px">
            @for (d of [7, 30, 90]; track d) {
              <button class="period-btn" [class.active]="preventionPeriodDays() === d" (click)="setPreventionPeriodDays(d)">
                {{ 'site.prevention.period.' + d | translate }}
              </button>
            }
          </div>

          <div class="card" style="margin-bottom:16px">
            <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px">
              <div class="engage-card" style="background:rgba(255,43,152,.06);border-color:rgba(255,43,152,.25)"><div class="engage-val" style="color:var(--a)">{{ preventionPerformanceAnalytics()?.opportunities ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.performance.opportunities' | translate }}</div>@if ((preventionPerformanceAnalytics()?.contextualOpportunities ?? 0) > 0) {<div class="cs" data-testid="performance-contextual-share" style="margin-top:2px">{{ 'site.prevention.performance.contextualShare' | translate: { count: $safeNavigationMigration(preventionPerformanceAnalytics()?.contextualOpportunities) } }}</div>}</div>
              <div class="engage-card"><div class="engage-val">{{ formatPreventionRate($safeNavigationMigration(preventionPerformanceAnalytics()?.interestRate)) }}</div><div class="engage-label">{{ 'site.prevention.performance.interestRate' | translate }}</div></div>
              <div class="engage-card" style="background:rgba(255,43,152,.06);border-color:rgba(255,43,152,.25)"><div class="engage-val" style="color:var(--a)">{{ formatPreventionPrice(preventionPerformanceAnalytics()?.opportunityValue ?? null, preventionPerformanceAnalytics()?.currency ?? null) }}</div><div class="engage-label">{{ 'site.prevention.performance.opportunitiesValue' | translate }}</div></div>
            </div>
          </div>

          <div class="card">
            <div class="ct" style="margin-bottom:14px">{{ 'site.prevention.performance.byOfferTitle' | translate }}</div>
            <div style="display:flex;flex-direction:column">
              @for (offer of preventionPerformanceAnalytics()?.offers ?? []; track offer.offerId) {
                <div class="flex-jb" style="padding:10px 0;border-bottom:1px solid var(--bd);cursor:pointer" (click)="openOfferDetail(offer.offerId)">
                  <div>
                    <div style="font-size:13px;font-weight:600;color:var(--ink)">{{ offer.offerName }}</div>
                    <div class="cs">{{ 'site.prevention.performance.reachedInterested' | translate:{ reached: offer.recommendationReached, interested: offer.interested } }}</div>
                  </div>
                  <div style="text-align:right">
                    <div style="font-size:13px;font-weight:700;color:var(--ink)">{{ formatPreventionPrice(offer.opportunityValue, 'EUR') }}</div>
                    <div class="cs">{{ formatPreventionRate(offer.interestRate) }}</div>
                  </div>
                </div>
              }
              @if ((preventionPerformanceAnalytics()?.offers ?? []).length === 0) {
                <div class="cs" style="text-align:center;padding:20px 0">{{ 'site.prevention.performance.empty' | translate }}</div>
              }
            </div>
          </div>

        }
      </div>
    }

    <!-- Home : 4 blocs -->
    @if (!showPreventionActivitySubpage() && !showPreventionCatalogSubpage() && !showPreventionJourneySubpage() && !showPreventionPerformanceSubpage()) {
    <div class="sat-grid">

      <!-- 1. Activité prévention -->
      <div class="card" style="grid-row:1;grid-column:1;height:320px;display:flex;flex-direction:column">
        <div class="flex-jb" style="margin-bottom:14px;flex-shrink:0">
          <div class="ct">{{ 'site.prevention.activity.title' | translate }}</div>
          <button class="btn-primary-sm" (click)="openPreventionActivity()">{{ 'site.common.seeMore' | translate }}</button>
        </div>
        <div style="display:flex;align-items:baseline;gap:10px;margin-bottom:14px;flex-wrap:wrap;flex-shrink:0">
          <span style="font-size:48px;font-weight:900;color:var(--ink);line-height:1;letter-spacing:-.04em">{{ preventionPerformance()?.interestedCount ?? '—' }}</span>
          <span style="display:inline-flex;align-items:center;gap:5px;color:var(--a);font-size:13px;font-weight:700">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--a)"><path d="M12 21s-6.7-4.3-9.3-8.2C1 10.1 1.6 6.6 4.6 5.1c2.2-1.1 4.6-.3 5.9 1.4l1.5 1.9 1.5-1.9c1.3-1.7 3.7-2.5 5.9-1.4 3 1.5 3.6 5 1.9 7.7C18.7 16.7 12 21 12 21z"/></svg>
            {{ 'site.prevention.activity.count' | translate }}
          </span>
        </div>
        <hr class="divider" style="flex-shrink:0">
        <div style="font-size:13px;font-weight:700;color:var(--ink);margin-bottom:10px;flex-shrink:0">{{ 'site.prevention.activity.recentTitle' | translate }}</div>
        <div style="display:flex;flex-direction:column;gap:6px;overflow-y:auto">
          @for (item of (preventionActivityPreview()?.items ?? []).slice(0, 3); track item.opportunityId) {
            <div class="flex-jb" style="padding:8px 10px;background:var(--bg);border:1px solid var(--bd);border-radius:8px">
              <div style="font-size:12px;font-weight:600;color:var(--ink)">{{ item.offerName }}@if (item.source === 'CONTEXTUAL_OFFER') {<span data-testid="activity-contextual-badge" style="display:inline-block;margin-left:6px;padding:1px 7px;border-radius:9px;background:rgba(255,184,0,.16);color:#7a5600;font-size:11px;font-weight:700;vertical-align:middle">{{ 'site.prevention.activity.contextualBadge' | translate }}</span>}</div>
              <div class="cs">{{ formatPreventionDate(item.interestAt) }}</div>
            </div>
          }
          @if (preventionActivityPreview() && preventionActivityPreview()!.items.length === 0) {
            <div class="cs">{{ 'site.prevention.activity.empty' | translate }}</div>
          }
        </div>
      </div>

      <!-- 2. Couverture & offres (Lot 9.0-E.E.G, étendu Lot V2A.5) -- résumé : offres ACTIVES uniquement,
           jamais tout le catalogue (section 25 du lot), + résumé Coverage compact (§8 du lot V2A.5) -->
      <div class="card" style="grid-row:1;grid-column:2;height:320px;display:flex;flex-direction:column">
        <div class="flex-jb" style="margin-bottom:14px;flex-shrink:0">
          <div class="ct">{{ 'site.prevention.offer.title' | translate }}</div>
          <button class="btn-primary-sm" (click)="openPreventionCatalog()">{{ 'site.common.seeMore' | translate }}</button>
        </div>
        <div style="margin-bottom:10px;flex-shrink:0" class="cs">
          {{ (activeOffersCount() > 1 ? 'site.prevention.offer.activeOffersCountPlural' : 'site.prevention.offer.activeOffersCountSingular') | translate: { count: activeOffersCount(), total: (preventionCatalog() ?? []).length } }}
        </div>

        @if (siteCoverageSummary(); as coverage) {
          <div class="coverage-strip" style="flex-shrink:0">
            @if (coverage.insufficientData) {
              <span class="cs">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
            } @else if (coverage.uncoveredNeedCount !== null && coverage.uncoveredNeedCount > 0) {
              <div class="coverage-strip-count">
                {{ (coverage.uncoveredNeedCount > 1 ? 'site.prevention.offer.coverage.uncoveredPlural' : 'site.prevention.offer.coverage.uncoveredSingular') | translate: { count: coverage.uncoveredNeedCount } }}
              </div>
              <button class="coverage-cta" (click)="onSiteCoverageCta(coverage.topGapReason)">{{ siteCoverageCtaLabel(coverage.topGapReason) }} →</button>
            } @else {
              <span class="cs">{{ 'site.prevention.offer.coverage.allCovered' | translate }}</span>
            }
          </div>
        }

        <div style="display:flex;flex-direction:column;gap:8px;overflow-y:auto">
          @for (offer of activeOffers(); track offer.offerId) {
            <div class="flex-jb" style="padding:8px 10px;background:var(--bg);border:1px solid var(--bd);border-radius:8px">
              <div style="display:flex;align-items:center;gap:8px">
                <span class="statut-dot" style="background:var(--gn)"></span>
                <span style="font-size:12px;font-weight:600;color:var(--ink)">{{ offer.name }}</span>
              </div>
              <span class="badge g">{{ formatPreventionPrice(offer.price, offer.currency) }}</span>
            </div>
          }
          @if (preventionCatalog() && activeOffersCount() === 0) {
            <div class="cs">{{ 'site.prevention.offer.noActiveOffers' | translate }}</div>
          }
        </div>
      </div>

      <!-- 3. Parcours patient -->
      <div class="card" style="grid-row:2;grid-column:1">
        <div class="flex-jb" style="margin-bottom:14px">
          <div class="ct">{{ 'site.prevention.journey.title' | translate }}</div>
          <button class="btn-primary-sm" (click)="openPreventionJourney()">{{ 'site.common.seeMore' | translate }}</button>
        </div>
        <div class="flex-jb" style="margin-bottom:10px">
          <span class="cs">{{ 'site.prevention.journey.exposureTitle' | translate }}</span>
          <span style="font-size:13px;font-weight:800;color:var(--mu)">{{ preventionFunnelAnalytics()?.exposed ?? '—' }} · {{ 'site.prevention.journey.exposed' | translate }}</span>
        </div>
        <hr class="divider" style="margin:0 0 12px">

        <div class="cs" style="margin-bottom:8px">{{ 'site.prevention.journey.participantsTitle' | translate }}</div>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px">
          <div class="engage-card"><div class="engage-val">@if (preventionFunnelWithheld()) {
<span class="cs" data-testid="funnel-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
} @else {
{{ preventionFunnelAnalytics()?.started ?? '—' }}
}</div><div class="engage-label">{{ 'site.prevention.journey.started' | translate }}</div></div>
          <div class="engage-card"><div class="engage-val">@if (preventionFunnelWithheld()) {
<span class="cs" data-testid="funnel-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
} @else {
{{ preventionFunnelAnalytics()?.completed ?? '—' }}
}</div><div class="engage-label">{{ 'site.prevention.journey.completed' | translate }}</div></div>
          <div class="engage-card"><div class="engage-val">{{ preventionFunnelAnalytics()?.recommendationsDisplayed ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.journey.recommendationsDisplayed' | translate }}</div></div>
        </div>
        <div class="engage-card" style="margin-top:10px;background:rgba(255,43,152,.06);border-color:rgba(255,43,152,.25)">
          <div class="engage-val" style="color:var(--a)">{{ preventionFunnelAnalytics()?.interested ?? '—' }}</div>
          <div class="engage-label">{{ 'site.prevention.journey.interested' | translate }}</div>
        </div>
        <div class="flex-jb" style="margin-top:10px">
          <span class="cs">{{ 'site.prevention.journey.completionRate' | translate }}</span>
          @if (preventionFunnelWithheld()) {
<span class="cs" data-testid="funnel-insufficient">{{ 'site.prevention.offer.coverage.insufficientData' | translate }}</span>
} @else {
<span style="font-size:14px;font-weight:800;color:var(--ink)">{{ formatPreventionRate($safeNavigationMigration(preventionFunnelAnalytics()?.completionRate)) }}</span>
}
        </div>
      </div>

      <!-- 4. Performance & impact -->
      <div class="card" style="grid-row:2;grid-column:2">
        <div class="flex-jb" style="margin-bottom:14px">
          <div class="ct">{{ 'site.prevention.performance.title' | translate }}</div>
          <button class="btn-primary-sm" (click)="openPreventionPerformance()">{{ 'site.common.seeMore' | translate }}</button>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px">
          <div class="engage-card"><div class="engage-val">{{ preventionPerformanceAnalytics()?.opportunities ?? '—' }}</div><div class="engage-label">{{ 'site.prevention.performance.opportunities' | translate }}</div>@if ((preventionPerformanceAnalytics()?.contextualOpportunities ?? 0) > 0) {<div class="cs" data-testid="performance-contextual-share" style="margin-top:2px">{{ 'site.prevention.performance.contextualShare' | translate: { count: $safeNavigationMigration(preventionPerformanceAnalytics()?.contextualOpportunities) } }}</div>}</div>
          <div class="engage-card"><div class="engage-val">{{ formatPreventionRate($safeNavigationMigration(preventionPerformanceAnalytics()?.interestRate)) }}</div><div class="engage-label">{{ 'site.prevention.performance.interestRate' | translate }}</div></div>
          <div class="engage-card"><div class="engage-val">{{ formatPreventionPrice(preventionPerformanceAnalytics()?.opportunityValue ?? null, preventionPerformanceAnalytics()?.currency ?? null) }}</div><div class="engage-label">{{ 'site.prevention.performance.opportunitiesValue' | translate }}</div></div>
        </div>
        @if (preventionTopOffers().length > 0) {
          <hr class="divider">
          <div class="cs" style="margin-bottom:8px">{{ 'site.prevention.performance.topOffer' | translate }}</div>
          <div style="display:flex;flex-direction:column;gap:6px">
            @for (offer of preventionTopOffers(); track offer.offerId; let i = $index) {
              <div class="flex-jb" style="padding:6px 10px;background:rgba(255,43,152,.06);border:1px solid rgba(255,43,152,.2);border-radius:8px">
                <div style="display:flex;align-items:center;gap:8px">
                  <span [style.background]="podiumColors[i]" style="width:18px;height:18px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:10px;font-weight:900;color:#fff;flex-shrink:0">{{ i + 1 }}</span>
                  <span style="font-size:12px;font-weight:600;color:var(--ink)">{{ offer.offerName }}</span>
                </div>
                <span style="font-size:12px;font-weight:800;color:var(--a)">{{ formatPreventionPrice(offer.opportunityValue, preventionPerformanceAnalytics()?.currency ?? null) }}</span>
              </div>
            }
          </div>
        }
      </div>

    </div>
    }
  }

  <!-- ════════════════════════════════════════ PARAMÈTRES DU SITE ════ -->
  @if (activeTab() === 'params') {

    <!-- Sous-page Informations générales / Établissement -->
    @if (showParamsSubpage()) {
      <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          @if (etablissementComp.showHorairesSubpage() || etablissementComp.showInformationsSubpage()) {
            <button class="breadcrumb-back" (click)="etablissementComp.showHorairesSubpage() ? etablissementComp.closeHorairesSubpage() : etablissementComp.closeInformationsSubpage()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              {{ 'site.common.back' | translate }}
            </button>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current breadcrumb-link" (click)="etablissementComp.closeHorairesSubpage(); etablissementComp.closeInformationsSubpage()">{{ 'site.breadcrumb.infosGenerales' | translate }}</span>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ (etablissementComp.showHorairesSubpage() ? 'site.breadcrumb.horaires' : 'site.breadcrumb.informations') | translate }}</span>
          } @else {
            <button class="breadcrumb-back" (click)="closeParams()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              {{ 'site.common.back' | translate }}
            </button>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ 'site.tabs.params' | translate }}</span>
            <span class="breadcrumb-sep">·</span>
            <span class="breadcrumb-current">{{ 'site.breadcrumb.infosGenerales' | translate }}</span>
          }
        </div>
        @if (!etablissementComp.showHorairesSubpage() && !etablissementComp.showInformationsSubpage()) {
          <div class="breadcrumb-actions">
            <button class="action-pill" (click)="etablissementComp.openHorairesSubpage()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              {{ 'site.breadcrumb.horaires' | translate }}
            </button>
          </div>
        }
      </div>
      <div class="params-subpage">
        <app-etablissement #etablissementComp [inline]="true"></app-etablissement>
      </div>
    }

    <!-- Sous-page Configuration du profil IA -->
    @if (showProfileIaSubpage()) {
      <div class="breadcrumb-bar">
        <button class="breadcrumb-back" (click)="closeProfileIa()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          {{ 'site.common.back' | translate }}
        </button>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.tabs.params' | translate }}</span>
        <span class="breadcrumb-sep">·</span>
        <span class="breadcrumb-current">{{ 'site.breadcrumb.profileIaConfig' | translate }}</span>
      </div>
      <div class="params-subpage">
        <app-profile-ia></app-profile-ia>
      </div>
    }

    <!-- DEPRECATED (2026-09-08) : sous-page "Équipements" masquée -- voir la note en tête de la
         carte résumé "Équipement" plus bas dans ce fichier (même périmètre, pipeline
         waitora-capteur non concernée).
    <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          <button class="breadcrumb-back" (click)="closeEquipements()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.tabs.params' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.equipement' | translate }}</span>
        </div>
        <div class="breadcrumb-actions">
          <button class="action-pill" (click)="equipementsComp.openUpsert(null)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            {{ 'site.equipements.addSensor' | translate }}
          </button>
        </div>
      </div>
      <div class="equipements-subpage">
        <app-equipements #equipementsComp [inline]="true" [defaultSiteId]="session.selectedId()"></app-equipements>
      </div>
    -->

    <!-- DEPRECATED (2026-09-08) : bloc "Gestion des équipes" masqué à la demande produit --
         décision de retirer la fonctionnalité (référentiels type de poste/compétence en premier
         lieu) ; en attendant la suppression complète (front + TeamController +
         org_skills/org_job_titles/user_skills/user_job_titles côté waitora-backend), le bloc est
         entièrement masqué ici et dans la carte résumé de l'onglet Paramètres (voir plus bas dans
         ce fichier). La gestion des utilisateurs reste accessible via les modales globales
         (Compte > Utilisateurs, Ajouter un utilisateur) -- non concernées par cette dépréciation.
    <div class="breadcrumb-bar breadcrumb-bar-with-actions">
        <div class="breadcrumb-left">
          <button class="breadcrumb-back" (click)="closeGestionEquipes()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            {{ 'site.common.back' | translate }}
          </button>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.tabs.params' | translate }}</span>
          <span class="breadcrumb-sep">·</span>
          <span class="breadcrumb-current">{{ 'site.breadcrumb.gestionEquipes' | translate }}</span>
        </div>
        <div class="breadcrumb-actions">
          @if (gestionEquipesComp.hasUserDroitPermission) {
            <button class="action-pill" (click)="gestionEquipesComp.openCreate()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              {{ 'site.common.add' | translate }}
            </button>
          }
        </div>
      </div>
      <div class="params-subpage">
        <app-gestion-equipes #gestionEquipesComp [inline]="true" [startInCreateMode]="gestionEquipesStartInCreate()"></app-gestion-equipes>
      </div>
    -->

    @if (!showParamsSubpage() && !showProfileIaSubpage() && !showEquipementsSubpage() && !showGestionEquipesSubpage()) {
    <div class="two-col">

      <!-- Colonne gauche -->
      <div class="col">

        <!-- Informations générales -->
        <div class="card">
          <div class="flex-jb" style="margin-bottom:14px">
            <div class="ct">{{ 'site.breadcrumb.infosGenerales' | translate }}</div>
            <button class="btn-primary-sm" (click)="openParams()">{{ 'site.common.edit' | translate }}</button>
          </div>
          <div style="display:flex;flex-direction:column;gap:10px">
            <div style="padding:12px;background:var(--bg);border:1px solid var(--bd);border-radius:10px">
              <div class="cs" style="font-weight:600;margin-bottom:10px">{{ 'site.params.infos.orgLogo' | translate }}</div>
              <div style="display:flex;align-items:center;gap:12px">
                @if (logoUrl()) {
                  <img [src]="logoUrl()" [attr.alt]="'site.params.infos.orgLogo' | translate" style="width:56px;height:56px;border-radius:10px;object-fit:contain;background:#fff;border:1px solid var(--bd);flex-shrink:0">
                } @else {
                  <div style="width:56px;height:56px;border-radius:10px;background:var(--ps);border:1px solid var(--bd);display:flex;align-items:center;justify-content:center;font-size:10px;color:var(--mu);text-align:center;line-height:1.3;flex-shrink:0">{{ 'site.params.infos.noLogo' | translate }}<br>{{ 'site.params.infos.noLogoLine2' | translate }}</div>
                }
                <div>
                  <div style="display:flex;align-items:center;gap:8px">
                    <label style="display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border-radius:8px;border:1px solid var(--bd);background:#fff;font-size:12px;font-weight:600;color:var(--ink);cursor:pointer" [class.disabled]="uploadingLogo()">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                      {{ (uploadingLogo() ? 'site.params.infos.uploading' : (logoUrl() ? 'site.params.infos.changeLogo' : 'site.params.infos.importLogo')) | translate }}
                      <input type="file" accept="image/png,image/jpeg,image/webp" style="display:none" [disabled]="uploadingLogo()" (change)="onLogoSelected($event)">
                    </label>
                    @if (logoUrl()) {
                      <button type="button" class="btn-danger-sm" (click)="openRemoveLogo()">{{ 'site.common.remove' | translate }}</button>
                    }
                  </div>
                  <div style="font-size:10px;color:var(--mu);margin-top:5px">{{ 'site.params.infos.orgLogoHint' | translate }}</div>
                </div>
              </div>
            </div>
            <div style="padding:12px;background:var(--bg);border:1px solid var(--bd);border-radius:10px">
              <div class="cs" style="font-weight:600;margin-bottom:10px">{{ 'site.params.infos.sitePhoto' | translate }}</div>
              <div style="display:flex;align-items:center;gap:12px">
                @if (photoUrl()) {
                  <img [src]="photoUrl()" [attr.alt]="'site.params.infos.sitePhoto' | translate" style="width:56px;height:56px;border-radius:10px;object-fit:cover;background:#fff;border:1px solid var(--bd);flex-shrink:0">
                } @else {
                  <div style="width:56px;height:56px;border-radius:10px;background:var(--ps);border:1px solid var(--bd);display:flex;align-items:center;justify-content:center;font-size:10px;color:var(--mu);text-align:center;line-height:1.3;flex-shrink:0">{{ 'site.params.infos.noPhoto' | translate }}<br>{{ 'site.params.infos.noPhotoLine2' | translate }}</div>
                }
                <div>
                  <div style="display:flex;align-items:center;gap:8px">
                    <label style="display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border-radius:8px;border:1px solid var(--bd);background:#fff;font-size:12px;font-weight:600;color:var(--ink);cursor:pointer" [class.disabled]="uploadingPhoto()">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                      {{ (uploadingPhoto() ? 'site.params.infos.uploading' : (photoUrl() ? 'site.params.infos.changePhoto' : 'site.params.infos.importPhoto')) | translate }}
                      <input type="file" accept="image/png,image/jpeg,image/webp" style="display:none" [disabled]="uploadingPhoto()" (change)="onPhotoSelected($event)">
                    </label>
                    @if (photoUrl()) {
                      <button type="button" class="btn-danger-sm" (click)="openRemovePhoto()">{{ 'site.common.remove' | translate }}</button>
                    }
                  </div>
                  <div style="font-size:10px;color:var(--mu);margin-top:5px">{{ 'site.params.infos.sitePhotoHint' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="info-row"><span class="info-key">{{ 'site.params.infos.siteName' | translate }}</span><span class="info-val">{{ estabDetails()?.name || '—' }}</span></div>
            <div class="info-row"><span class="info-key">{{ 'site.params.infos.address' | translate }}</span><span class="info-val">{{ estabDetails()?.address || '—' }}</span></div>
            <div class="info-row"><span class="info-key">{{ 'site.breadcrumb.horaires' | translate }}</span><span class="info-val">{{ formatOpeningHours(estabDetails()?.opening_hours ?? []) }}</span></div>
            <div class="info-row"><span class="info-key">{{ 'site.params.infos.placeId' | translate }}</span><span class="info-val" style="font-family:monospace;font-size:11px">{{ estabDetails()?.place_id || '—' }}</span></div>
            <div class="info-row"><span class="info-key">{{ 'site.params.infos.timezone' | translate }}</span><span class="info-val">{{ estabDetails()?.tz || '—' }}</span></div>
            <div class="info-row">
              <span class="info-key">{{ 'site.params.infos.language' | translate }}</span>
              <span class="info-val info-val-langs">
                @for (lang of languesDisplay(); track lang.code) {
                  <span class="lang-chip"><img [src]="flagIcon(lang.code)" [alt]="lang.label" class="lang-chip-flag">{{ lang.label }}</span>
                } @empty {
                  —
                }
              </span>
            </div>
          </div>
        </div>

        <!-- DEPRECATED (2026-09-08) : carte résumé "Gestion des équipes" masquée -- voir la note
             de dépréciation en tête de la sous-page juste au-dessus dans ce fichier.
        <div class="card">
          <div class="flex-jb" style="margin-bottom:14px">
            <div class="ct">{{ 'site.breadcrumb.gestionEquipes' | translate }}</div>
            @if (hasUserDroitPermission) {
              <button class="btn-primary-sm" (click)="openGestionEquipes()">{{ 'site.common.seeMore' | translate }}</button>
            }
          </div>
          <div class="cs" style="margin-bottom:14px">{{ 'site.params.team.subtitle' | translate }}</div>
          @if (siteUsers().length > 0) {
            <div class="members-scroll" style="display:flex;flex-direction:column;gap:10px">
              @for (u of siteUsers(); track u.id) {
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="avatar" [ngStyle]="userAvatarStyle(u)">{{ userInitials(u) }}</div>
                  <div class="person-info">
                    <div class="person-name">{{ u.first_name }} {{ u.last_name }}</div>
                    @if (userJobTitleLabel(u); as jt) {
                      <div class="person-role">{{ jt }}</div>
                    } @else {
                      <div class="person-role">{{ u.email }}</div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="cs" style="color:var(--mu);text-align:center;padding:12px 0">{{ 'site.params.team.empty' | translate }}</div>
          }
        </div>
        -->

      </div>

      <!-- Colonne droite -->
      <div class="col">

        <!-- Configuration des données d’organisation -->
        <div class="card">
          <div class="flex-jb" style="margin-bottom:14px">
            <div class="ct">{{ 'site.params.orgData.title' | translate }}</div>
            <button class="btn-primary-sm" (click)="openProfileIa()">{{ 'site.common.seeMore' | translate }}</button>
          </div>

          <!-- Demande, Jours -->
          <div class="toggle-label" style="margin-bottom:14px">{{ 'site.params.orgData.demandDays' | translate }}</div>
          @if (demandDays(); as days) {
            <div style="display:flex;flex-direction:column;gap:12px">
              <div>
                <div class="toggle-sub" style="margin-bottom:6px">{{ 'site.params.orgData.lowDays' | translate }}</div>
                <div class="day-group">
                  @for (d of wizardDays; track d) {
                    <span [class]="days.isLow(d) ? 'day-pill day-pill-active' : 'day-pill'">{{ dayShortLabel(d) }}</span>
                  }
                </div>
              </div>
              <div>
                <div class="toggle-sub" style="margin-bottom:6px">{{ 'site.params.orgData.normalDays' | translate }}</div>
                <div class="day-group">
                  @for (d of wizardDays; track d) {
                    <span [class]="days.isNormal(d) ? 'day-pill day-pill-active' : 'day-pill'">{{ dayShortLabel(d) }}</span>
                  }
                </div>
              </div>
              <div>
                <div class="toggle-sub" style="margin-bottom:6px">{{ 'site.params.orgData.highDays' | translate }}</div>
                <div class="day-group">
                  @for (d of wizardDays; track d) {
                    <span [class]="days.isHigh(d) ? 'day-pill day-pill-active' : 'day-pill'">{{ dayShortLabel(d) }}</span>
                  }
                </div>
              </div>
            </div>
          } @else if (!wizardConfigLoading()) {
            <div class="cs" style="color:var(--mu);text-align:center;padding:12px 0">{{ 'site.params.orgData.notConfigured' | translate }}</div>
          }
        </div>

        <!-- DEPRECATED (2026-09-08) : carte "Équipement" masquée -- UNIQUEMENT l'UI de consultation
             des capteurs (siteEquipements/orgSnapshot ci-dessous côté site.component.ts +
             EquipementsController côté backend). La pipeline waitora-capteur (Orange LoRaWAN,
             calcul d'occupation) N'EST PAS concernée, reste active, utilisée par
             supervision.component.ts pour le temps d'attente réel.
        <div class="card">
          <div class="flex-jb" style="margin-bottom:4px">
            <div class="ct">{{ 'site.breadcrumb.equipement' | translate }}</div>
            @if (hasEquipementsPermission) {
              <button class="btn-primary-sm" (click)="openEquipements()">{{ 'site.common.seeMore' | translate }}</button>
            }
          </div>
          <div class="cs" style="margin-bottom:14px">{{ 'site.params.equipements.subtitle' | translate }}</div>
          @if (siteEquipements().length > 0) {
            <div style="display:flex;flex-direction:column;gap:10px">
              @for (e of siteEquipements(); track e.id) {
                <div class="capteur-card">
                  <div class="flex-jb" style="margin-bottom:8px">
                    <div style="display:flex;align-items:center;gap:8px">
                      <div [class]="'capteur-icon' + (e.statut === 'OK' ? ' capteur-icon-g' : '')">📡</div>
                      <div>
                        <div class="toggle-label">{{ e.capteur }}</div>
                        <div class="toggle-sub">{{ e.lieu ?? e.deviceType ?? '—' }}</div>
                      </div>
                    </div>
                    <span [class]="'badge ' + statutBadge(e.statut)">{{ statutLabel(e.statut) }}</span>
                  </div>
                  <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px">
                    <div class="capteur-stat">
                      <div class="capteur-stat-val">{{ e.batterie !== null ? e.batterie + '%' : '—' }}</div>
                      <div class="capteur-stat-label">{{ 'site.params.equipements.battery' | translate }}</div>
                    </div>
                    <div class="capteur-stat">
                      <div class="capteur-stat-val">{{ formatDerniereDonnee(e.derniereTrameAt) }}</div>
                      <div class="capteur-stat-label">{{ 'site.params.equipements.lastSync' | translate }}</div>
                    </div>
                    <div class="capteur-stat">
                      <div class="capteur-stat-val">{{ e.accumulatedIn ?? '—' }}</div>
                      <div class="capteur-stat-label">{{ 'site.params.equipements.todayPassages' | translate }}</div>
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="cs" style="color:var(--mu);text-align:center;padding:12px 0">{{ 'site.params.equipements.empty' | translate }}</div>
          }
        </div>
        -->

      </div>

    </div>
    } <!-- /!showParamsSubpage && !showProfileIaSubpage && !showEquipementsSubpage && !showGestionEquipesSubpage -->
  }

  @if (removeLogoOpen()) {
    <app-confirm-modal
      [title]="'site.params.removeLogoModal.title' | translate"
      [message]="'site.params.removeLogoModal.message' | translate"
      [confirmText]="'site.common.remove' | translate"
      [cancelText]="'site.common.cancel' | translate"
      [loading]="removeLogoLoading()"
      [errorMessage]="removeLogoError()"
      (confirm)="confirmRemoveLogo()"
      (cancel)="closeRemoveLogo()">
    </app-confirm-modal>
  }

  @if (removePhotoOpen()) {
    <app-confirm-modal
      [title]="'site.params.removePhotoModal.title' | translate"
      [message]="'site.params.removePhotoModal.message' | translate"
      [confirmText]="'site.common.remove' | translate"
      [cancelText]="'site.common.cancel' | translate"
      [loading]="removePhotoLoading()"
      [errorMessage]="removePhotoError()"
      (confirm)="confirmRemovePhoto()"
      (cancel)="closeRemovePhoto()">
    </app-confirm-modal>
  }

  @if (removeOfferTarget()) {
    <app-confirm-modal
      [title]="'site.prevention.offer.removeConfirmTitle' | translate"
      [message]="'site.prevention.offer.removeConfirmMessageActive' | translate"
      [confirmText]="'site.common.remove' | translate"
      [cancelText]="'site.common.cancel' | translate"
      [loading]="removingOffer()"
      [errorMessage]="removeOfferError()"
      (confirm)="confirmRemoveOffer()"
      (cancel)="closeRemoveOfferConfirm()">
    </app-confirm-modal>
  }

  @if (showLeaveOfferFormConfirm()) {
    <app-confirm-modal
      [title]="'site.prevention.offer.leaveFormConfirm.title' | translate"
      [message]="'site.prevention.offer.leaveFormConfirm.message' | translate"
      [confirmText]="'site.prevention.offer.leaveFormConfirm.confirmButton' | translate"
      [cancelText]="'site.prevention.offer.leaveFormConfirm.cancelButton' | translate"
      (confirm)="confirmLeaveOfferForm()"
      (cancel)="cancelLeaveOfferForm()">
    </app-confirm-modal>
  }


</div>
